(function () {
    'use strict';
    angular
        .module('MW.Influencers.SearchV2', [
            'angular-inview',
            'MW.CoreStream.CsSelectAllHeader',
            'MW.ContactManager.OnEnterAction',
            'MW.ContactManager.MwSearchInput',
            'MW.Framework.ContentStreamDataFactory',
            'MW.Framework.ContentStreamSelectionDecorator',
            'MW.Framework.InfluencerContactService',
            'MW.CoreStream.ContactManagerTagService',
            'ngRoute',
            'ngMaterial',
            'mwAppComponents',
            'MW.ContactManager.MwExpansionPanel',
            'MW.ContactManager.MwLocationExpansionPanel',
            'MW.ContactManager.MwEmailAddressExpansionPanel',
            'MW.ContactManager.MwListStatusExpansionPanel',
            'LanguageService',
            'MW.Influencers.IcmLanguageService',
            'MW.Influencers.IcmDialogService',
            'MW.Framework.RelevantArticlesDialogService',
            'MW.Influencers.FilterFactory',
            'MW.Framework.PageStateService',
            'MW.Framework.ICMUserService',
            'MW.Framework.CoreUserService',
            'MW.Framework.CoreCompanyService',
            'MW.ContactManager.SelectionFactory',
            'MW.ContactManager.MwBeatsHeader',
            'MW.Framework.EntitlementService',
            'MW.Influencers.MiniProfileService',
            'MW.ContactManager.MwMapModal',
            'MW.Influencers.AnalyticsService',
            'MW.Influencers.MapService',
            'MW.Influencers.CloudwatchService',
            'MW.Framework.MomentService'
        ])
        .controller('SearchControllerV2', [
            '$window',
            '$route',
            '$location',
            '$rootScope',
            '$scope',
            '$translate',
            '$mdDialog',
            '$mdToast',
            '$timeout',
            '$http',
            'ContactStreamDataFactory',
            'SourceStreamDataFactory',
            'ContentStreamSelectionDecorator',
            'InfluencerContactService',
            'ContactManagerTagService',
            'IcmLanguageService',
            'DialogService',
            'RelevantArticlesDialogService',
            '$q',
            'FilterFactory',
            'LocationFilter',
            'PageStateService',
            'ICMUserService',
            'CoreUserService',
            'CoreCompanyService',
            'BeatFilter',
            'SourceFilter',
            'EmailFilter',
            'ListStatusFilter',
            'MAX_MEDIALIST_LIMIT',
            'EntitlementService',
            'MiniProfileService',
            'AnalyticsService',
            'MapService',
            'CloudwatchService',
            'moment',
            'countryMapping',
            '$sce',
            'allContactsCount',
            'ICM_CSS_URL',
            SearchControllerV2
        ]);

    function SearchControllerV2($window,
        $route,
        $location,
        $rootScope,
        $scope,
        $translate,
        $mdDialog,
        $mdToast,
        $timeout,
        $http,
        ContactStreamDataFactory,
        SourceStreamDataFactory,
        ContentStreamSelectionDecorator,
        InfluencerContactService,
        ContactManagerTagService,
        IcmLanguageService,
        DialogService,
        RelevantArticlesDialogService,
        $q,
        FilterFactory,
        LocationFilter,
        PageStateService,
        ICMUserService,
        CoreUserService,
        CoreCompanyService,
        BeatFilter,
        SourceFilter,
        EmailFilter,
        ListStatusFilter,
        MAX_MEDIALIST_LIMIT,
        EntitlementService,
        MiniProfileService,
        AnalyticsService,
        MapService,
        CloudwatchService,
        moment,
        countryMapping,
        $sce,
        allContactsCount,
        ICM_CSS_URL
    ) {
        $rootScope.$on('currentTabSelected', () => {
            this.resetPageState();
        });

        $rootScope.$on('clearAll', () => {
            this.clearAll();
        });

        this.allContactsCount = allContactsCount;
        this.MiniProfileService = MiniProfileService;
        this.CloudwatchService = CloudwatchService;
        this.moment = moment;
        this.countryMapping = countryMapping.data;
        this.$window = $window;
        this.$route = $route;
        this.$location = $location;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;
        this.$timeout = $timeout;
        this.$http = $http;
        this.$q = $q;
        this.$sce = $sce;
        this.previousQuery = {};
        this.PageStateService = PageStateService;
        this.ICMUserService = ICMUserService;
        this.CoreUserService = CoreUserService;
        this.CoreCompanyService = CoreCompanyService;
        this.IcmLanguageService = IcmLanguageService;
        this.DialogService = DialogService;
        this.RelevantArticlesDialogService = RelevantArticlesDialogService;
        this.InfluencerContactService = InfluencerContactService;
        this.ContactManagerTagService = ContactManagerTagService;
        this.ContactStreamDataForRelevant = new ContactStreamDataFactory();
        this.SourceStreamDataForNames = new SourceStreamDataFactory();
        this.ContactStreamDataForNames = new ContactStreamDataFactory();
        this.SourceStreamDataForRelevant = new SourceStreamDataFactory();
        this.MAX_MEDIALIST_LIMIT = MAX_MEDIALIST_LIMIT;
        this.LOCKER_NAMESPACE = 'searchState';
        this.expansionTabs = [1, 2];
        this.MapService = MapService;
        this.EntitlementService = EntitlementService;
        this.AnalyticsService = AnalyticsService;
        this.showLocationSuggest = false;
        this.autoProfilesSplitIo = false;
        this.improvedKeyWordSplit = false;
        this.translatedCountryList = [];
        this.userLanguage = false;
        this.relevantSearchLoading = false;
        this.nameSearchLoading = false;
        this.relevantQuery = {};
        this.ICM_CSS_URL = ICM_CSS_URL;

        // Get AppSettings for the page
        this.contactSettings = null;
        this.contentStreamSettings = null;
        this.CoreUserService.getCurrent(true).then(function getUser(currentUser) {
            if (currentUser._id) {
                this.ICMUserService.getAppSettings('contacts', currentUser._id)
                    .then(function(contactSettings) {
                        if (contactSettings) {
                            this.contactSettings = contactSettings;
                        }
                    }.bind(this));

                this.ICMUserService.getAppSettings('sharedContentStreamSettings', currentUser._id)
                    .then(function(contentStreamSettings) {
                        if (contentStreamSettings) {
                            this.contentStreamSettings = contentStreamSettings;
                        }
                    }.bind(this));
            }
        }.bind(this));

        this.viewport = {
            topLeft: null,
            bottomRight: null
        };
        this.mapView = true;
        this.updateMapSearch = false;

        this.detectedBeats = [];
        this.datePickerOptions = [
            {
                display: this.$translate.instant('icm-search__date-picker--14-days'),
                loadingText: 'icm-search__loading-text--14-days',
                value: 14,
                materialSyntax: {
                    name: 'Last 14 days',
                    type: 'last14Days'
                }
            },
            {
                display: this.$translate.instant('icm-search__date-picker--30-days'),
                loadingText: 'icm-search__loading-text--30-days',
                value: 30,
                materialSyntax: {
                    name: 'Last 30 days',
                    type: 'last30Days'
                }
            },
            {
                display: this.$translate.instant('icm-search__date-picker--90-days'),
                loadingText: 'icm-search__loading-text--90-days',
                value: 90,
                materialSyntax: {
                    name: 'Last 90 days',
                    type: 'last90Days'
                }
            }
        ];
        this.dateRangeTypes = this.datePickerOptions.map((datePickerOption) => {
            return datePickerOption.materialSyntax.type;
        });

        this.ContactSelectorForRelevant = new ContentStreamSelectionDecorator({
            idField: 'id',
            filterName: 'contactRelevantFilter'
        });
        this.ContactSelectorForNames = new ContentStreamSelectionDecorator({
            idField: 'id',
            filterName: 'contactFilter'
        });
        // filters
        this.beatsFilter = new BeatFilter('icm-search__beats-filter--title', this.refreshBeatSearch.bind(this));
        this.reachesFilter = new FilterFactory('icm-search__reach-filter--title', this.refreshSearch.bind(this));
        this.rolesFilter = new FilterFactory('icm-search__role-filter--title', this.refreshSearch.bind(this));
        this.mediaChannelsFilter = new FilterFactory('icm-search__mediaChannel-filter--title', this.refreshSearch.bind(this));
        this.newsFocusesFilter = new FilterFactory('icm-search__geographicRegion-filter--title', this.refreshSearch.bind(this));
        this.frequenciesFilter = new FilterFactory('icm-search__frequency-filter--title', this.refreshSearch.bind(this));
        this.languagesFilter = new FilterFactory('icm-search__language-filter--title', this.refreshSearch.bind(this));
        this.locationsFilter = new LocationFilter('icm-search__location-filter--title', this.refreshSearch.bind(this));
        this.sourcesFilter = new SourceFilter('icm-search__sourceName-filter--title', this.refreshSearch.bind(this));
        this.emailsFilter = new EmailFilter('Email Filter Title', this.refreshSearch.bind(this));
        this.listStatusFilter = new ListStatusFilter('icm-search__list-status-filter--title', this.refreshSearch.bind(this));
        this.scrollDiv = 'mi-app-chrome-content-slot';
        // debounce promises
        this.findFilterPromise = null;
        this.filterChangePromise = null;

        this.initializeDefaultAggs();

        // page state stuff
        this.pageState = {};

        this.pageState.searchText = '';
        this.pageState.searchChips = [];
        this.pageState.findStringRelevant = '';
        this.pageState.findStringNamed = '';
        this.pageState.sortField = 'relevance';
        this.pageState.searchPlaceholder = 'icm-search__default-search-placeholder';
        this.pageState.sourceSearchPlaceholder = 'icm-search__source-search-placeholder';
        this.pageState.dateRangeDays = this.datePickerOptions[0].value;
        this.pageState.miniProfileContactId = '';
        this.resetMaterialDatePicker();

        this.pageState.hideStream = true;
        this.pageState.emptyState = true;
        this.pageState.noResults = false;
        this.pageState.showFilters = true;
        this.pageState.forceShowFilters = false;
        this.pageState.isContactSearch = true;
        this.pageState.isRelevantSelected = false;
        this.pageState.pageRefresh = false;
        //Map Stuff - before page state
        this.pageState.mapFilterCheckbox = false;
        this.showLocationTabSwitchModal = true;
        this.pageState.mapActive = false;

        $scope.$on('$locationChangeStart', function(event, next) { // PAGE CHANGE
            if (!next.includes('icm-web/influencers/search/v2')) {
                this.pageState.pageRefresh = true;
                this.setPageState();
                window.removeEventListener('app-chrome-drawer-closed', closeMini, false);
            }
        }.bind(this));

        window.addEventListener('beforeunload', function() { // PAGE REFRESH
            this.pageState.pageRefresh = true;
            this.setPageState();
        }.bind(this));

        window.addEventListener('app-chrome-drawer-closed', closeMini, false);

        function closeMini() {
            let _this = angular.element(document.getElementsByClassName('searchPage')).scope().searchController;
            if(_this.pageState.pageRefresh === false){
                _this.MiniProfileService.closeMiniProfile();
                _this.pageState.miniProfileContactId = '';
                _this.setPageState();
                _this.$scope.$apply();
            }
        }

        this.initializeSearchTypeOptions();

        this.userLanguage = this.CoreUserService.getLanguage();
        this.cachedAllAggs = this.PageStateService.getItem('allAggs', null, this.LOCKER_NAMESPACE);
        if (this.cachedAllAggs && this.cachedAllAggs.userLanguage !== this.userLanguage) {
            this.cachedAllAggs = null;
        }
        if (this.$location.search().locker && this.PageStateService.get(this.$location.search().locker, null, this.LOCKER_NAMESPACE) !== null) {
            this.pageState = this.PageStateService.get(this.$location.search().locker, null, this.LOCKER_NAMESPACE);
            // Get all the possible filter options beforehand
            this.searchForNonRelevantFilterOptions().then(() => {
                this.insertNonRelevantFilterOptions();
            }).catch(() => { });

            // the bounds object should have the mapboxgl class of LngLatBounds
            // it gets changed to raw json in the pagestate, so need to re-add the class
            if (this.pageState.viewportBounds && this.pageState.viewportBounds.bounds && this.pageState.viewportBounds.bounds._ne && this.pageState.viewportBounds.bounds._sw) {
                this.pageState.viewportBounds.bounds = new $window.mapboxgl.LngLatBounds(this.pageState.viewportBounds.bounds._sw, this.pageState.viewportBounds.bounds._ne);
            }
            this.MapService.initialize(this.pageState.viewportBounds);
            this.initializePageFromState();
        }
        else {
            this.initializeLockerState();

            // load up the initial filter options here
            this.loadAggsOnly().then(() => {
                // Get all the possible filter options beforehand
                this.searchForNonRelevantFilterOptions().then((allAggs) => {
                    this.insertNonRelevantFilterOptions(allAggs);
                }).catch(() => { });
            });
        }

        //Map Stuff - after page state
        this.MapService.registerRefreshSearch(this.refreshSearch.bind(this));
        this.MapService.registerLocationFilter(this.locationsFilter.selectionFactory);

        this.pageState.mapFilterCheckboxCopy = this.pageState.mapFilterCheckbox;

        this.findFilterExpandedRelevant = !!this.pageState.findStringRelevant;
        this.findFilterExpandedNamed = !!this.pageState.findStringNamed;
        this.showSearchDropDown = false;

        this.$rootScope.$on('clearLocationFilter', function() {
            this.clearLocationFilter();
        }.bind(this));

        this.NAME_SEARCH_TAB = 'nameSearchTab';
        this.RELEVANT_SEARCH_TAB = 'relevantSearchTab';

        this.activeSearchTab = (this.pageState.isRelevantSelected ? this.RELEVANT_SEARCH_TAB : this.NAME_SEARCH_TAB);

        this.isNameSearchFilterActive = ((this.pageState.findStringNamed.length > 0) ? true : false);
        this.isKeywordSearchFilterActive = ((this.pageState.findStringRelevant.length > 0) ? true : false);
    }

    // SEARCH_VERSION_TOGGLE
    SearchControllerV2.prototype.openOptOutModal = function openOptOutModal() {
        var _this = this;

        _this.$mdDialog.show(
            _this.$mdDialog.mwMiniModal({
                templateUrl: 'icm-web/views/opt_out_modal',
                locals:{
                    reason: ''
                },
                clickOutsideToClose: true
            })
        )
        .then(
            function okHandler(reason) {
                var redirectUrl = '/influencers/search?searchVersion=v1';
                if(_this.$location.search().locker) {
                    redirectUrl += `&locker=${_this.$location.search().locker}`;
                }

                sessionStorage.setItem('icm.search.optout.reeason', reason);
                _this.$location.url(redirectUrl);
            },
            function cancelHandler() {
                _this.$mdDialog.hide();
            }
        )
        .catch(function () {});
    };

    SearchControllerV2.prototype.getTranslatedResultString = function getTranslatedResultString(count) {
        const itemCount = Math.max(0, count);
        const message = (itemCount === 1) ? 'icm-search__map-filter--result-count' : 'icm-search__map-filter--results-count';

        return this.$translate.instant(message, {itemCount: itemCount});
    };

    SearchControllerV2.prototype.toggleSearchFilter = function toggleSearchFilter() {
        if(this.pageState.isRelevantSelected) {
            if(this.isKeywordSearchFilterActive === true) {
                this.isKeywordSearchFilterActive = false;
                this.findfilterSearchRelevant('');
            } else {
                this.isKeywordSearchFilterActive = true;
            }
        } else {
            if(this.isNameSearchFilterActive === true) {
                this.isNameSearchFilterActive = false;
                this.findfilterSearchNamed('');
            } else {
                this.isNameSearchFilterActive = true;
            }
        }
    };

    SearchControllerV2.prototype.resetPageState = function resetPageState() {
        this.setSearchType();

        // page state stuff
        this.clearAll();
        this.pageState = {};
        this.initializeDefaultAggs();
        this.pageState.searchText = '';
        this.pageState.searchChips = [];
        this.pageState.findStringRelevant = '';
        this.pageState.findStringNamed = '';
        this.pageState.sortField = 'relevance';
        this.pageState.searchPlaceholder = 'icm-search__default-search-placeholder';
        this.pageState.sourceSearchPlaceholder = 'icm-search__source-search-placeholder';
        this.pageState.dateRangeDays = this.datePickerOptions[0].value;
        this.resetMaterialDatePicker();
        this.PageStateService.miniProfileContactId = '';
        this.pageState.hideStream = true;
        this.pageState.emptyState = true;
        this.pageState.noResults = false;
        this.pageState.showFilters = true;
        this.pageState.forceShowFilters = false;
        this.pageState.isContactSearch = true;
        this.pageState.mapFilterCheckbox = false;

        this.initializeSearchTypeOptions();
        this.setPageState();
        this.searchForNonRelevantFilterOptions()
            .then(() => {
                this.insertNonRelevantFilterOptions();
            })
            .catch(() => { });
    };

    SearchControllerV2.prototype.initializeSearchTypeOptions = function initializeSearchTypeOptions() {
        this.pageState.searchTypeOptions = [
            {
                title: 'icm-search__type--influencers',
                type: 'contact',
                selected: false,
                placeholder: this.$translate.instant('icm-search__influencers-placeholder')
            },
            {
                title: 'icm-search__type--influencers-who-write-about',
                type: 'relevantContact',
                selected: false,
                placeholder: this.$translate.instant('icm-search__relevant-influencers-placeholder')
            },
            {
                title: 'icm-search__type--sources',
                type: 'source',
                selected: false,
                placeholder: this.$translate.instant('icm-search__sources-placeholder')
            },
            {
                title: 'icm-search__type--sources-who-write-about',
                type: 'relevantSource',
                selected: false,
                placeholder: this.$translate.instant('icm-search__relevant-sources-placeholder')
            }
        ];
    };

    SearchControllerV2.prototype.initializeDefaultAggs = function initializeDefaultAggs() {
        var defaultContactAggs = [
            { type: 'countriesAndRegions' },
            { type: 'beats' },
            { type: 'roles' },
            { type: 'sourcesReachTiers' },
            { type: 'languages' },
            { type: 'sourcesMediaChannels' },
            { type: 'sourcesNewsFocuses' },
            { type: 'sourcesFrequencies' },
            { type: 'sources', size: 1 }
        ],
            defaultSourceAggs = [
                { type: 'countriesAndRegions' },
                { type: 'beats' },
                { type: 'reachTiers' },
                { type: 'mediaChannels' },
                { type: 'newsFocuses' },
                { type: 'frequencies' },
                { type: 'languages' }
            ];

        this.defaultAggs = {
            contact: defaultContactAggs,
            relevantContact: defaultContactAggs,
            source: defaultSourceAggs,
            relevantSource: defaultSourceAggs
        };
    };
    SearchControllerV2.prototype.getUpdateButtonText = function getUpdateButtonText() {
        if (this.pageState.isContactSearch) {
            return 'icm-search__map-filter--reload-result';
        } else {
            return 'icm-search__map-filter--reload-result-sources';
        }
    };

    SearchControllerV2.prototype.initializeLockerState = function initializeLockerState() {
        if (this.PageStateService.lockerId.searchState) {
            delete this.PageStateService.lockerId.searchState;
        }

        if (this.$location.search().locker) {
            delete this.$location.search().locker;
        }

        this.PageStateService.initializeSaveState('searchState');
        this.PageStateService.set(this.$location.search().locker, this.pageState, this.LOCKER_NAMESPACE);
    };

    SearchControllerV2.prototype.initializePageFromState = function initializePageFromState() {
        if (this.pageState.pageRefresh && this.pageState.miniProfileContactId) {
            this.MiniProfileService.openMiniProfile(this.pageState.miniProfileContactId, false); // False is used to match refresh state to stop prevent default from running since the user didnt click anything
        }
        this.pageState.pageRefresh = false;

        if (this.pageState.aggs) {
            this.updateFiltersBasedOnAggs(this.pageState.aggs);
        }
        this.updateFilterSelection();
        this.pageState.findStringRelevant = this.pageState.findStringRelevant || ''; //for Find Filter Search
        this.pageState.findStringNamed = this.pageState.findStringNamed || ''; //for Find Filter Search
        this.previousQuery = this.pageState.previousQuery || {};
        this.searchForBoth(true);
        this.setPageState();
    };

    /*
     ----------------------------------
     -------- View Functions ---------
     ----------------------------------
     */
    SearchControllerV2.prototype.getDateRangeForContentHeader = function getDateRangeForContentHeader() {
        if (this.pageState.isRelevantSelected && (!!this.pageState.searchText.length || !!this.pageState.searchChips.length)) {
            return this.pageState.dateRangeDays;
        } else {
            return -1;
        }
    };

    SearchControllerV2.prototype.getLoadingText = function getLoadingText() {
        var currentIndex,
            localizedString;
        this.datePickerOptions.some(function (obj, i) {
            return obj.value === this.pageState.dateRangeDays ? (currentIndex = i, true) : false;
        }.bind(this));

        if (currentIndex === undefined) {
            return '';
        }

        localizedString = this.datePickerOptions[currentIndex].loadingText;
        return this.$translate.instant(localizedString);
    };

    SearchControllerV2.prototype.getInfoTip = function getInfoTip(filterName) {
        var searchType = this.getSelectedSearchType(),
            localizedString = 'icm-search__';

        if (searchType === 'contact' || searchType === 'relevantContact') {
            localizedString += 'influencer-filters--';
            if (filterName === 'location') {
                localizedString += 'map-';
            }
            localizedString += filterName + '-infoTip';
        }
        else {
            localizedString += 'source-filters--';
            if (filterName === 'location') {
                localizedString += 'map-';
            }
            localizedString += filterName + '-infoTip';
        }
        return this.$translate.instant(localizedString);
    };

    SearchControllerV2.prototype.viewContact = function viewContact(contact) {
        this.pageState.miniProfileContactId = contact.id;
        this.MiniProfileService.openMiniProfile(this.pageState.miniProfileContactId, true);
        this.setPageState();
        this.InfluencerContactService.setCurrentContact(contact);
    };

    SearchControllerV2.prototype.highlightSelectedContact = function selectedContact(cardContactID) {
        return cardContactID === this.MiniProfileService.miniProfileId;
    };

    SearchControllerV2.prototype.showActionButtons = function showActionButtons(selectedItems) {
        return Object.keys(selectedItems).length > 0;
    };

    SearchControllerV2.prototype.getSelectedCount = function getSelectedCount(selectedItems) {
        if(selectedItems) {
            return Object.keys(selectedItems).length;
        }
        return 0;
    };

    SearchControllerV2.prototype.getSelectedCountFromSelector = function getSelectedCountFromSelector(selector, totalContacts) {
        var selectedCount;

        if(selector.trueAllSelected) {
            selectedCount = totalContacts;
        } else {
            selectedCount = Object.keys(selector.selectedItems).length;
        }

        return selectedCount;
    };

    // this function will determine when to grey-out the background. if auto-suggest menu (includes suggestions) is visible, grey-out the background
    SearchControllerV2.prototype.setAutoSuggestVisibility = function setAutoSuggestVisibility(isVisible) {
        if (isVisible) {
            if (this.pageState.searchText && this.pageState.searchText.length >= 2 && this.pageState.searchChips.length === 0) {
                this.autoSuggestVisible = true;
            }
        } else {
            this.autoSuggestVisible = false;
            $('.contentWrapper').show();
            this.pageState.showFilters = true;
            //Need to trigger a scroll event on the containing element
            //so that the content stream sticky header will render correctly
            $('md-content.mw-flex-padding').trigger('scroll');
        }
    };

    SearchControllerV2.prototype.updateBeatChips = function updateBeatChips(searchChips) {
        return searchChips.filter(function (searchChip) {
            if (searchChip.beat) {
                return this.beatsFilter.selectionFactory.isSelected(searchChip.beat);
            } else {
                return true;
            }
        }, this);
    };

    SearchControllerV2.prototype.refreshBeatSearch = function refreshBeatSearch() {
        this.pageState.searchChips = this.updateBeatChips(this.pageState.searchChips);

        this.refreshSearch();
    };

    SearchControllerV2.prototype.refreshSearch = function refreshSearch() {
        if (this.filterChangePromise) {
            this.$timeout.cancel(this.filterChangePromise);
        }
        this.filterChangePromise = this.$timeout(() => {
            this.searchForBoth();
        }, 600);
    };

    /*
        -----------------------------------------
        -------- AutoSuggest Functions ----------
        -----------------------------------------
    */
    SearchControllerV2.prototype.autoSuggestSourceNames = function autoSuggestSourceNames(searchText) {
        return this.$q(resolve => {
            return this.buildSearchQuery(this.pageState.searchText, this.pageState.searchChips, [{
                type: 'sources',
                q: searchText
            }], 0).then(query => {
                query.page = 0;
                let promiseArray = [this.InfluencerContactService.aggregateContactSearch(query)];
                let relevantQuery = JSON.parse(JSON.stringify(query));
                if(relevantQuery.orQ.length !== 0 ||( relevantQuery.relevantQ && relevantQuery.relevantQ.length !== 0)) {
                    relevantQuery.docQuery = {
                        dateStart: this.moment().tz(this.ICMUserService.getTimezone()).subtract(this.pageState.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString(),
                        dateEnd: this.moment().tz(this.ICMUserService.getTimezone()).endOf('day').toISOString()
                    };
                    promiseArray.push(this.InfluencerContactService.aggregateRelevantContacts(relevantQuery));
                }
                return this.$q.all(promiseArray);
            }).then(response => {
                var sourceNameAggregations = [],
                    combinedAggs,
                    selectedSources,
                    nameAggs = (response[0] && response[0].aggs) ? response[0].aggs : '',
                    relevantAggs = (response[1] && response[1].aggs) ? response[1].aggs : '';

                combinedAggs = this.combineAggregations(nameAggs, relevantAggs);

                if (Object.keys(combinedAggs).length !== 0) {
                    this.updateFiltersBasedOnAggs(combinedAggs);
                    selectedSources = this.sourcesFilter.getSelectedValues();
                    sourceNameAggregations = combinedAggs.sources
                        .map(function (sourceNameObject) {
                            return sourceNameObject;
                        })
                        .filter(function (option) {
                            return !selectedSources.some(function (selectedOption) {
                                return option.key === selectedOption;
                            }.bind(this));
                        }.bind(this));
                }

                resolve(sourceNameAggregations);
            });
        });
    };

    function combineAggregationsChildren ( nameAggChild, relevantAggChild) {
        let allChildren = [];
        if(nameAggChild.length && !relevantAggChild.length){
            return nameAggChild;
        } else if(!nameAggChild.length && relevantAggChild.length){
            return relevantAggChild;
        } else if(nameAggChild.length && relevantAggChild.length) {
            allChildren = JSON.parse(JSON.stringify(nameAggChild));
            _.forEach(relevantAggChild, function(relChild){
               let matchIndex =_.findIndex(allChildren, function(matchChild){
                    return matchChild.key === relChild.key;
               });
               if(matchIndex === -1){
                 allChildren.push(relChild);
               } else {
                 allChildren[matchIndex].count += relChild.count;
               }
            });
        } else {
            return [];
        }
        return allChildren;
    }

    SearchControllerV2.prototype.combineAggregations = function( nameAggs, relevantAggs) {
        let allAggs = {};
        if(nameAggs && !relevantAggs){
            return nameAggs;
        } else if(!nameAggs && relevantAggs){
            return relevantAggs;
        } else if(nameAggs && relevantAggs) {
            allAggs = JSON.parse(JSON.stringify(nameAggs));
            _.forEach(relevantAggs, function(agg, key){
                if(allAggs[key]){
                    relevantAggs[key].forEach(function(relAgg){
                       let matchIndex =_.findIndex(allAggs[key], function(matchAgg){
                            return matchAgg.key === relAgg.key;
                       });
                       if(matchIndex === -1){
                         allAggs[key].push(relAgg);
                       } else {
                         allAggs[key][matchIndex].count += relAgg.count;

                         if(allAggs[key][matchIndex].children || relAgg.children){
                           allAggs[key][matchIndex].children = combineAggregationsChildren(allAggs[key][matchIndex].children, relAgg.children);
                         }
                       }
                    });
                } else {
                    allAggs[key] = agg;
                }
            });
        } else {
            return {};
        }
        return allAggs;
    };

    /*
     ----------------------------------
     -------- Filter Functions ---------
     ----------------------------------
     */

    SearchControllerV2.prototype.updateFilterSelection = function updateFilterSelection() {
        if (this.pageState.beatsFilter) {
            this.beatsFilter.selectionFactory.displayState = this.pageState.beatsFilter;
        }
        if (this.pageState.locationsFilter) {
            this.locationsFilter.selectionFactory.displayState = this.pageState.locationsFilter.selectionFactory.displayState;
            Object.values(this.locationsFilter.selectionFactory.displayState.selected).forEach(function (option) {
                this.locationsFilter.selectionFactory.select(option);
            }.bind(this));
        }
        if (this.pageState.rolesFilter) {
            this.rolesFilter.selectionFactory.displayState = this.pageState.rolesFilter.selectionFactory.displayState;
        }
        if (this.pageState.reachesFilter) {
            this.reachesFilter.selectionFactory.displayState = this.pageState.reachesFilter;
        }
        if (this.pageState.mediaChannelsFilter) {
            this.mediaChannelsFilter.selectionFactory.displayState = this.pageState.mediaChannelsFilter;
        }
        if (this.pageState.newsFocusesFilter) {
            this.newsFocusesFilter.selectionFactory.displayState = this.pageState.newsFocusesFilter;
        }
        if (this.pageState.frequenciesFilter) {
            this.frequenciesFilter.selectionFactory.displayState = this.pageState.frequenciesFilter;
        }
        if (this.pageState.languagesFilter) {
            this.languagesFilter.selectionFactory.displayState = this.pageState.languagesFilter.selectionFactory.displayState;
        }
        if (this.pageState.sourcesFilter) {
            this.sourcesFilter.selectionFactory.displayState = this.pageState.sourcesFilter;
        }
        if (this.pageState.emailsFilter) {
            this.emailsFilter.selectedEmails = this.pageState.emailsFilter;
        }
        if (this.pageState.listStatusFilter) {
            this.listStatusFilter.selectedOption = this.pageState.listStatusFilter;
        }
    };

    SearchControllerV2.prototype.resetSelections = function resetSelections() {
        this.ContactSelectorForNames.deselectAll();
        this.ContactSelectorForRelevant.deselectAll();
    };

    SearchControllerV2.prototype.searchInputChanged = function searchInputChanged(searchText) {
        this.pageState.searchText = searchText;
        this.setPageState();

        if (searchText === '' && this.pageState.searchChips.length === 0 && this.isRelevantSearch()) {
            this.clearAll();
        }
    };

    SearchControllerV2.prototype.isRelevantSearch = function isRelevantSearch() {
        return this.getSelectedSearchType() === 'relevantContact' || this.getSelectedSearchType() === 'relevantSource';
    };

    SearchControllerV2.prototype.resetMaterialDatePicker = function resetMaterialDatePicker() {
        this.pageState.selectedDateRange = {
            name: 'Last 14 days',
            type: 'last14Days'
        };
    };

    SearchControllerV2.prototype.selectDatePicker = function selectDatePicker(option) {
        this.pageState.selectedDateRange = option;

        this.datePickerOptions.some((datePickerOption) => {
            if(datePickerOption.materialSyntax.type === option.type) {
                this.pageState.dateRangeDays = datePickerOption.value;
                return true;
            }
        });

        this.MiniProfileService.closeMiniProfile();
        this.pageState.pageRefresh = false;
        this.pageState.miniProfileContactId = '';
        this.setPageState();


        if(this.pageState.isContactSearch){
            this.searchDifferent(this.pageState.searchText, this.pageState.searchChips, null, this.pageState.searchTypeOptions[1].type, true);
        } else {
            this.searchDifferent(this.pageState.searchText, this.pageState.searchChips, null, this.pageState.searchTypeOptions[3].type, true);
        }
    };

    SearchControllerV2.prototype.initializeContactSampleSearch = function initializeContactSampleSearch() {
        this.resetChipSummary();
        this.selectInfluencers();
        if (this.beatsFilter.selectionFactory.currentOptions.length === 0) {
            this.updateFiltersBasedOnAggs(this.cachedAllAggs.contact);
        }

        this.beatsFilter.selectionFactory.selectByKey('494c9425-5727-4ec3-95f0-33cd2778d8ba');
        this.reachesFilter.selectionFactory.selectByKey('tier_1');
        this.searchForBoth();
    };

    SearchControllerV2.prototype.initializeSourceSampleSearch = function initializeSourceSampleSearch() {
        this.resetChipSummary();
        this.selectSources();
        if (this.beatsFilter.selectionFactory.currentOptions.length === 0) {
            this.updateFiltersBasedOnAggs(this.cachedAllAggs.source);
        }

        this.beatsFilter.selectionFactory.selectByKey('78ed275a-a2cf-4067-abfd-7ef00f35eeff');
        this.reachesFilter.selectionFactory.selectByKey('tier_1');
        this.searchForBoth();
    };

    /*
     ----------------------------------
     -------- Clear Functions ---------
     ----------------------------------
     */

    // cleared from the expansion panel
    SearchControllerV2.prototype.clearSourcesFilter = function clearSourcesFilter(ignoreSearch) {

        this.sourcesFilter.clearAll();
        this.pageState.sourcesFilter = null;

        if (!ignoreSearch) {
            this.sourcesFilter.waitOnSearch();
           //        this.search(this.pageState.searchText, this.pageState.searchChips);
         this.searchForBoth();
        }
    };

    SearchControllerV2.prototype.clearLocationFilter = function clearLocationFilter() {
        // if were clearing it, we need to wait on the search
        this.isSwitchingLocationFilters = true;
        this.clearMapsViewportBounds();
        this.locationsFilter.waitOnSearch();
        this.locationsFilter.clearAll();
        this.pageState.mapFilterCheckbox = false;
        this.pageState.locationsFilter = null;
        this.totalContacts = undefined;
        this.MapService.boundsSelected(this.startingBounds);
        this.pageState.mapActive = false;
        // this.search(this.pageState.searchText, this.pageState.searchChips).finally(() => {
        this.searchForBoth().finally(() =>{
            this.isSwitchingLocationFilters = false;
        });
    };

    SearchControllerV2.prototype.clearBeatsFilter = function clearBeatsFilter() {
        // if were clearing it, we need to wait on the search
        this.beatsFilter.waitOnSearch();
        this.beatsFilter.clearAll();
        this.pageState.beatsFilter = null;

        // need to call this AFTER beatsFilter.clearAll
        this.pageState.searchChips = this.updateBeatChips(this.pageState.searchChips);

        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearRolesFilter = function clearRolesFilter() {
        // if were clearing it, we need to wait on the search
        this.rolesFilter.waitOnSearch();
        this.rolesFilter.clearAll();
        this.pageState.rolesFilter = null;
        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearReachesFilter = function clearReachesFilter(ignoreSearch) {
        // if were clearing it, we need to wait on the search
        this.reachesFilter.waitOnSearch();
        this.reachesFilter.clearAll();
        this.pageState.reachesFilter = null;
        if (!ignoreSearch) {
            this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
        }
    };

    SearchControllerV2.prototype.clearMediaChannelsFilter = function clearMediaChannelsFilter() {
        // if were clearing it, we need to wait on the search
        this.mediaChannelsFilter.waitOnSearch();
        this.mediaChannelsFilter.clearAll();
        this.pageState.mediaChannelsFilter = null;
        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearNewsFocusesFilter = function clearNewsFocusesFilter() {
        // if were clearing it, we need to wait on the search
        this.newsFocusesFilter.waitOnSearch();
        this.newsFocusesFilter.clearAll();
        this.pageState.newsFocusesFilter = null;
        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearFrequenciesFilter = function clearFrequenciesFilter() {
        // if were clearing it, we need to wait on the search
        this.frequenciesFilter.waitOnSearch();
        this.frequenciesFilter.clearAll();
        this.pageState.frequenciesFilter = null;
        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearLanguagesFilter = function clearLanguagesFilter() {
        // if were clearing it, we need to wait on the search
        this.languagesFilter.waitOnSearch();
        this.languagesFilter.clearAll();
        this.pageState.frequenciesFilter = null;
        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearEmailsFilter = function clearEmailsFilter() {
        // if we're clearing it, we need to wait on the search
        this.emailsFilter.waitOnSearch();
        this.emailsFilter.clearAll();
        this.pageState.emailsFilter = null;
        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearListStatusFilter = function clearListStatusFilter() {
        // if we're clearing it, we need to wait on the search
        this.listStatusFilter.waitOnSearch();
        this.listStatusFilter.clearAll();
        this.pageState.listStatusFilter = null;
        this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
    };

    SearchControllerV2.prototype.clearAll = function clearAll(clickedAutoSuggest) {
        this.MiniProfileService.closeMiniProfile();

        var searchType = this.getSelectedSearchType();
        clickedAutoSuggest = clickedAutoSuggest || false;
        //This DOM update was taking too long, so... let's use animation frames instead
        window.requestAnimationFrame(() => {
            this.MapService.setInteractionState(this.MapService.HELPER_TEXT);
        });
        this.$rootScope.$broadcast('clearLocationFilter');
        this.beatsFilter.clearAll();
        this.rolesFilter.clearAll();
        this.reachesFilter.clearAll();
        this.mediaChannelsFilter.clearAll();
        this.newsFocusesFilter.clearAll();
        this.frequenciesFilter.clearAll();
        this.languagesFilter.clearAll();
        this.emailsFilter.clearAll();
        this.listStatusFilter.clearAll();
        this.clearSourcesFilter(true);
        this.mapSearchText = '';
        this.MapService.cachedViewportBounds = this.setDefaultMapView(this.getCountriesList(), this.countryMapping);
        this.totalContacts = undefined;
        this.pageState.isRelevantSelected = false;

        this.ContactStreamDataForRelevant.resetSearch();
        this.ContactStreamDataForNames.resetSearch();
        this.SourceStreamDataForRelevant.resetSearch();
        this.SourceStreamDataForNames.resetSearch();

        this.findFilterExpandedRelevant = false;
        this.findFilterExpandedNamed = false;
        this.pageState.mapFilterCheckbox = false;
        this.pageState.locationsFilter = null;
        this.pageState.beatsFilter = null;
        this.pageState.rolesFilter = null;
        this.pageState.reachesFilter = null;
        this.pageState.mediaChannelsFilter = null;
        this.pageState.newsFocusesFilter = null;
        this.pageState.frequenciesFilter = null;
        this.pageState.languagesFilter = null;
        this.pageState.sourcesFilter = null;
        this.pageState.emailsFilter = null;
        this.pageState.listStatusFilter = null;
        this.pageState.miniProfileContactId = '';
        this.pageState.pageRefresh = false;
        this.pageState.searchText = '';
        this.pageState.findStringRelevant = ''; //for Find Filter Search
        this.pageState.findStringNamed = ''; //for Find Filter Search
        this.pageState.namedAggs = {};
        this.pageState.relevantAggs = {};
        if (!clickedAutoSuggest) {
            this.pageState.searchText = '';
            this.pageState.searchChips.length = 0;
        }

        collapseAllFilters();

        this.resetChipSummary();
        this.locationsFilter.updateQuery('', [], searchType, [], this.pageState.dateRangeDays);

        if (!clickedAutoSuggest) {
            // Use cached default aggs (if there) instead of searching for them
            if (!this.pageState.searchText && this.pageState.searchChips.length === 0 && this.cachedAllAggs) {
                var emptyStateAggs;
                if (this.pageState.isContactSearch) {
                    emptyStateAggs = this.cachedAllAggs.contact;
                } else {
                    emptyStateAggs = this.cachedAllAggs.source;
                }
                this.updateFiltersBasedOnAggs(emptyStateAggs);

                // reset the empty state
                this.pageState.noResults = false;
                this.pageState.hideStream = true;
                this.pageState.emptyState = true;

                this.setPageState();
            }
            this.searchForBoth(this.pageState.searchText, this.pageState.searchChips);
        }

        this.activeSearchTab = this.NAME_SEARCH_TAB;
        this.isNameSearchFilterActive = false;
        this.isKeywordSearchFilterActive = false;
    };

    SearchControllerV2.prototype.allFiltersWaitOnSearch = function allFiltersWaitOnSearch() {
        this.locationsFilter.waitOnSearch();
        this.beatsFilter.waitOnSearch();
        this.rolesFilter.waitOnSearch();
        this.reachesFilter.waitOnSearch();
        this.mediaChannelsFilter.waitOnSearch();
        this.newsFocusesFilter.waitOnSearch();
        this.frequenciesFilter.waitOnSearch();
        this.languagesFilter.waitOnSearch();
        this.emailsFilter.waitOnSearch();
        this.listStatusFilter.waitOnSearch();
    };

    /*
        ----------------------------------
        -------- Find Filter Functions ---------
        ----------------------------------
    */

    SearchControllerV2.prototype.buildFindFilterQuery = function buildFindFilterQuery(searchType, query) {
        let findQuery = {};
        findQuery.type = (searchType === 'contact' || searchType === 'relevantContact') ? 'freeTextContact' : 'freeTextSource';
        if(searchType.indexOf('relevant') > -1) {
            if (this.pageState.findStringRelevant.length) {
                  findQuery.q = this.pageState.findStringRelevant;
                  query.filters.push(findQuery);
            }
        } else {
            if (this.pageState.findStringNamed.length) {
                findQuery.q = this.pageState.findStringNamed;
                query.filters.push(findQuery);
            }
        }
        return query;
    };

    /*
     ----------------------------------
     -------- Search Functions ---------
     ----------------------------------
     */

    // Insert the non relevant options into a filter
    SearchControllerV2.prototype.insertNonRelevantFilterOptions = function insertNonRelevantFilterOptions(allAggsObj) {
        var searchType = this.getSelectedSearchType(),
            filterNames,
            allAggs;

        // return if a search type is not selected
        if (!searchType) {
            return;
        }

        // new Stuff
        if (this.pageState.isContactSearch) {
            // stop if we already did this
            if (this.previousSearchType === 'contact' && !allAggsObj) {
                return;
            } else {
                this.previousSearchType = 'contact';
            }

            filterNames = [
                {
                    filter: 'locationsFilter',
                    optionsField: 'countriesAndRegions'
                },
                {
                    filter: 'beatsFilter',
                    optionsField: 'beats'
                },
                {
                    filter: 'languagesFilter',
                    optionsField: 'languages'
                },
                {
                    filter: 'newsFocusesFilter',
                    optionsField: 'sourcesNewsFocuses'
                },
                {
                    filter: 'frequenciesFilter',
                    optionsField: 'sourcesFrequencies'
                },
                {
                    filter: 'reachesFilter',
                    optionsField: 'sourcesReachTiers'
                },
                {
                    filter: 'mediaChannelsFilter',
                    optionsField: 'sourcesMediaChannels'
                },
                {
                    filter: 'rolesFilter',
                    optionsField: 'roles'
                }
            ];
            if (this.cachedAllAggs) {
                allAggs = this.cachedAllAggs.contact;
            }

        } else {
            // cache
            if (this.previousSearchType === 'source' && !allAggsObj) {
                return;
            } else {
                this.previousSearchType = 'source';
            }

            filterNames = [
                {
                    filter: 'locationsFilter',
                    optionsField: 'countriesAndRegions'
                },
                {
                    filter: 'beatsFilter',
                    optionsField: 'beats'
                },
                {
                    filter: 'languagesFilter',
                    optionsField: 'languages'
                },
                {
                    filter: 'newsFocusesFilter',
                    optionsField: 'newsFocuses'
                },
                {
                    filter: 'frequenciesFilter',
                    optionsField: 'frequencies'
                },
                {
                    filter: 'reachesFilter',
                    optionsField: 'reachTiers'
                },
                {
                    filter: 'mediaChannelsFilter',
                    optionsField: 'mediaChannels'
                }
            ];
            if (this.cachedAllAggs) {
                allAggs = this.cachedAllAggs.source;
            }
        }
        if (this.cachedAllAggs) {
            filterNames.forEach(function (filterName) {
                this[filterName.filter].setAllOptions(allAggs[filterName.optionsField]);
            }.bind(this));
        }
        this.getTranslatedCountriesList();
    };

    // Update filters based on aggs of search response
    SearchControllerV2.prototype.updateFiltersBasedOnAggs = function updateFiltersBasedOnAggs(aggs) {
        var freshAggs;

        if (aggs.countriesAndRegions) {
            aggs.countriesAndRegions = aggs.countriesAndRegions.map(function (location) {
                location.name = location.key;
                return location;
            });
            this.locationsFilter.updateOptions(aggs.countriesAndRegions);
        }

        if (aggs.beats) {
            this.childBeats = getChildBeats(aggs.beats);
            this.autoSuggestBeats = aggs.beats.concat(this.childBeats);
            this.beatsFilter.updateOptions(aggs.beats);
        }
        if (aggs.languages) {
            this.languages = this.mapLanguage(aggs.languages);
            this.languagesFilter.updateOptions(this.languages);
        }

        if (aggs.sourcesNewsFocuses) {
            freshAggs = aggs.sourcesNewsFocuses;
            this.newsFocusesFilter.updateOptions(freshAggs);
        } else if (aggs.newsFocuses) {
            freshAggs = aggs.newsFocuses;
            this.newsFocusesFilter.updateOptions(aggs.newsFocuses);
        }

        if (aggs.sourcesFrequencies) {
            freshAggs = aggs.sourcesFrequencies;
            this.frequenciesFilter.updateOptions(freshAggs);
        } else if (aggs.frequencies) {
            freshAggs = aggs.frequencies;
            this.frequenciesFilter.updateOptions(freshAggs);
        }

        if (aggs.roles) {
            this.rolesFilter.updateOptions(aggs.roles);
        }

        if (aggs.reachTiers || aggs.sourcesReachTiers) {
            var reachAggs = aggs.reachTiers || aggs.sourcesReachTiers;
            this.reachTiers = this.mapReaches(reachAggs);
            this.reachesFilter.updateOptions(this.reachTiers);
        }

        if (aggs.sourcesMediaChannels) {
            freshAggs = aggs.sourcesMediaChannels;
            this.mediaChannelsFilter.updateOptions(aggs.sourcesMediaChannels);
        } else if (aggs.mediaChannels) {
            freshAggs = aggs.mediaChannels;
            this.mediaChannelsFilter.updateOptions(aggs.mediaChannels);
        }

        if (aggs.sources) {
            this.sourcesFilter.updateOptions(aggs.sources);
        }

        if (aggs.viewport) {
            this.viewport.topLeft = aggs.viewport.topLeft;
            this.viewport.bottomRight = aggs.viewport.bottomRight;
        }

        this.setPageState();
    };

    SearchControllerV2.prototype.buildSearchQuery = function buildSearchQuery(searchText, searchChips, aggregations, contactPageSize, searchType) {
        return this.$q(resolve => {
            return this.CoreUserService.getCurrent(true).then(() => {
                var query = {
                        pageSize: (isNaN(contactPageSize) ? 25 : contactPageSize),
                        filters: this.buildSearchFilters(),
                        aggregations: this.buildSearchAggregations(aggregations),
                        orQ: [],
                        language: this.CoreUserService.getLanguage()
                    },
                    trimmedSearchText = (searchText ? searchText.trim() : '');

                // Set the search query
                if (searchType && searchType.startsWith('relevant')) {
                    query.relevantQ = trimmedSearchText;
                } else {
                    query.q = trimmedSearchText;
                }

                //making chips and searchText mutually exclusive
                if (trimmedSearchText === '' && searchChips && searchChips.length > 0) {
                    query.orQ = getSearchChipValues(searchChips);
                }

                if (!searchText && query.orQ.length === 0 && !(Array.isArray(query.filters) && query.filters.length) && !!query.listStatus) {
                    query.pageSize = 0;
                }

                if (this.listStatusFilter.selectedOption !== null) {
                    query.listStatus = this.listStatusFilter.selectedOption;
                    this.pageState.listStatusFilter = this.listStatusFilter.selectedOption;
                }
                resolve(query);
            });
        });
    };

    SearchControllerV2.prototype.buildSearchAggregations = function buildSearchAggregations(aggregations) {
        var aggs = [];

        if (aggregations) {
            aggs = aggregations;
        } else if (this.getSelectedSearchType() !== false) {
            aggs = this.defaultAggs[this.getSelectedSearchType()];
        }

        return aggs;
    };

    /*
     ----------------------------------
     -------- Map Functions ---------
     ----------------------------------
     */

    SearchControllerV2.prototype.mapViewSelected = function (bool) {
        this.mapView = bool;
    };

    SearchControllerV2.prototype.setDefaultMapView = function setDefaultMapView(countries, countryMapping) {
        countries = countries.map(text => {
            if (typeof text === 'string') {
                return text.toLowerCase();
            } else {
                return text;
            }
        });

        let bounds = this.MapService.DEFAULT_VIEWPORT_BOUNDS.bounds;
        let defaultBounds = [[bounds._sw.lng, bounds._sw.lat], [bounds._ne.lng, bounds._ne.lat]];
        if (countries.length === 1) {
            let bbox = [];

            countryMapping.forEach(country => {
                if (country.name && countries.indexOf(country.name.toLowerCase()) > -1) {
                    bbox.push([country.bbox[0], country.bbox[1]]);
                    bbox.push([country.bbox[2], country.bbox[3]]);
                }
            });

            this.startingBounds = bbox.length === 2 ? bbox : defaultBounds;

        } else {
            this.startingBounds = defaultBounds;
        }

        return this.startingBounds;
    };

    SearchControllerV2.prototype.clearMapsViewportBounds = function () {
        this.pageState.viewportBounds = undefined;
        this.viewport = {
            bottomRight: null,
            topLeft: null
        };
        this.MapService.clear();
    };

    SearchControllerV2.prototype.browseGeoHash = function browseGeoHash() {
        if (this.mapChangePromise) {
            this.$timeout.cancel(this.mapChangePromise);
        }

        return this.$q((resolve, reject) => {
            var aggs = [],
                searchType = this.getSelectedSearchType(),
                searchChips = this.pageState.searchChips;

            this.mapChangePromise = this.$timeout(() => {
                return this.buildSearchQuery(null, searchChips, aggs, 0).then(query => {
                    query.page = 0;
                    query.pageSize = 1;
                    switch (searchType) {
                        case 'contact':
                            this.InfluencerContactService.aggregateContactSearch(query).then(res => {
                                resolve(res);
                            });
                            break;
                        case 'relevantContact':
                            this.InfluencerContactService.aggregateRelevantContacts(query).then(res => {
                                resolve(res);
                            });
                            break;
                        case 'source':
                            this.InfluencerContactService.aggregateSourceSearch(query).then(res => {
                                resolve(res);
                            });
                            break;
                        case 'relevantSource':
                            this.InfluencerContactService.aggregateRelevantSources(query).then(res => {
                                resolve(res);
                            });
                            break;
                        default:
                            reject('Invalid searchType');
                            break;
                    }
                });
            }, 600);
        });
    };

    /*
     ----------------------------------
     -------- Search Functions ---------
     ----------------------------------
     */

    SearchControllerV2.prototype.buildSearchFilters = function buildSearchFilters() {
        var filters = [],
            selectedLocations = this.locationsFilter.selectionFactory.getQuerySelections(),
            selectedViewportBounds = this.MapService.getViewportBounds(),
            selectedChildBeats = this.beatsFilter.selectionFactory.getSelectedChildren(),
            type;

        // get selected beats to filter
        if (selectedChildBeats.length > 0) {
            this.pageState.beatsFilter = this.beatsFilter.selectionFactory.displayState;
            var filter = {
                type: 'beats',
                values: []
            }, sortingHat = {};

            // Get the children into the right objects
            selectedChildBeats.forEach(function (childBeat) {
                return sortingHat[childBeat.parentKey] ? sortingHat[childBeat.parentKey].push(childBeat.key) : sortingHat[childBeat.parentKey] = [childBeat.key];
            });

            Object.keys(sortingHat).forEach(function (parentKey) {
                filter.values.push({
                    parent: parentKey,
                    children: sortingHat[parentKey]
                });
            });

            filters.push(filter);
        }

        if (this.mapView && selectedViewportBounds && this.pageState.mapActive) {
            this.pageState.viewportBounds = selectedViewportBounds;
            filters.push({
                type: 'viewport',
                topLeft: selectedViewportBounds.getViewport().topLeft,
                bottomRight: selectedViewportBounds.getViewport().bottomRight
            });
        }
        else if (selectedLocations.length > 0) {
            this.pageState.locationsFilter = this.locationsFilter;
            filters.push({
                type: 'locations',
                values: selectedLocations.map(function (location) {
                    var locationQueryObject = {};

                    switch (location.level.toLowerCase()) {
                        case 'country':
                            locationQueryObject.country = location.key;
                            break;
                        case 'region':
                            locationQueryObject.country = location.country;
                            locationQueryObject.region = location.key;
                            break;
                        case 'city':
                            locationQueryObject.country = location.country;
                            locationQueryObject.region = location.region;
                            locationQueryObject.city = location.city || location.name;
                            break;
                        default:
                            break;
                    }

                    return locationQueryObject;
                })
            });
        }

        if (this.newsFocusesFilter.getSelectedCount() > 0) {
            this.pageState.newsFocusesFilter = this.newsFocusesFilter.selectionFactory.displayState;
            type = this.pageState.isContactSearch ? 'sourcesNewsFocuses' : 'newsFocuses';
            filters.push({
                type: type,
                values: this.newsFocusesFilter.getSelectedValues()
            });
        }

        if (this.reachesFilter.getSelectedCount() > 0) {
            type = this.pageState.isContactSearch ? 'sourcesReachTiers' : 'reachTiers';
            this.pageState.reachesFilter = this.reachesFilter.selectionFactory.displayState;

            filters.push({
                type: type,
                values: this.reachesFilter.getSelectedValues()
            });
        }

        if (this.frequenciesFilter.getSelectedCount() > 0) {
            this.pageState.frequenciesFilter = this.frequenciesFilter.selectionFactory.displayState;
            type = this.pageState.isContactSearch ? 'sourcesFrequencies' : 'frequencies';
            filters.push({
                type: type,
                values: this.frequenciesFilter.getSelectedValues()
            });
        }

        if (this.mediaChannelsFilter.getSelectedCount() > 0) {
            this.pageState.mediaChannelsFilter = this.mediaChannelsFilter.selectionFactory.displayState;
            type = this.pageState.isContactSearch ? 'sourcesMediaChannels' : 'mediaChannels';
            filters.push({
                type: type,
                values: this.mediaChannelsFilter.getSelectedValues()
            });
        }

        ['languages', 'roles'].forEach(function (filterType) {
            var filterName = filterType + 'Filter';

            if (this[filterName].getSelectedCount() > 0) {
                this.pageState[filterName] = this[filterName];
                filters.push({
                    type: filterType,
                    values: this[filterName].getSelectedValues()
                });
            }
        }, this);

        // filter by source name
        if (this.sourcesFilter.getSelectedCount() > 0) {
            this.pageState.sourcesFilter = this.sourcesFilter.selectionFactory.displayState;
            filters.push({
                type: 'sources',
                sourceIds: this.sourcesFilter.getSelectedValues()
            });
        }

        // filter by email address
        if (this.emailsFilter.getSelectedCount() > 0) {
            this.pageState.emailsFilter = this.emailsFilter.selectedEmails;
            filters.push({
                type: 'emails',
                values: this.emailsFilter.selectedEmails
            });
        }

        return filters;
    };

    SearchControllerV2.prototype.findfilterSearchRelevant = function findfilterSearchRelevant(searchTerm) {
        // do nothing if attempting to search on the same filter term
        if(this.pageState.findStringRelevant === searchTerm) {
            return;
        }

        if (this.findFilterPromise) {
            this.$timeout.cancel(this.findFilterPromise);
        }

        let searchPromise;
        this.pageState.findStringRelevant = searchTerm || '';
        this.setPageState();

        this.findFilterPromise = this.$timeout(() => {
            if(this.pageState.isContactSearch){
                searchPromise = this.searchDifferent(this.pageState.searchText, this.pageState.searchChips, null, this.pageState.searchTypeOptions[1].type, true);
            } else {
                searchPromise = this.searchDifferent(this.pageState.searchText, this.pageState.searchChips, null, this.pageState.searchTypeOptions[3].type, true);
            }
        }, 300);
    };

    SearchControllerV2.prototype.findfilterSearchNamed = function findfilterSearch(searchTerm) {
        // do nothing if attempting to search on the same filter term
        if(this.pageState.findStringNamed === searchTerm) {
            return;
        }

       if (this.findFilterPromise) {
           this.$timeout.cancel(this.findFilterPromise);
       }

       this.pageState.findStringNamed = searchTerm || '';
       this.setPageState();

        this.findFilterPromise = this.$timeout(() => {
            if(this.pageState.isContactSearch){
                this.searchDifferent(this.pageState.searchText, this.pageState.searchChips, null, this.pageState.searchTypeOptions[0].type, true);
            } else {
                this.searchDifferent(this.pageState.searchText, this.pageState.searchChips, null, this.pageState.searchTypeOptions[2].type, true);
            }

        }, 300);
    };

    SearchControllerV2.prototype.searchTextHasChanged = function searchTextHasChanged(searchType, searchText) {
        if (searchType === 'contact' || searchType === 'source') {
            return this.previousQuery.q !== searchText;
        } else if (searchType === 'relevantContact' || searchType === 'relevantSource') {
            return this.previousQuery.relevantQ !== searchText;
        }
        return false;
    };

    SearchControllerV2.prototype.getCountriesList = function getCountriesList() {
        let countries = [];
        if (this.cachedAllAggs && this.cachedAllAggs.contact && this.cachedAllAggs.contact.countriesAndRegions) {

            this.cachedAllAggs.contact.countriesAndRegions.forEach(country => {
                countries.push(country.key.toLowerCase());
            });
        }

        return countries;
    };

    SearchControllerV2.prototype.getTranslatedCountriesList = function getTranslatedCountriesList() {
        if (this.cachedAllAggs && this.cachedAllAggs.contact && this.cachedAllAggs.contact.countriesAndRegions) {
            this.translatedCountryList = [];
            this.cachedAllAggs.contact.countriesAndRegions.forEach(country => {
                this.translatedCountryList.push(country.display);
            });
        }
    };

    SearchControllerV2.prototype.searchForNonRelevantFilterOptions = function () {
        let promises = [];

        promises.push(this.CoreUserService.getCurrent(true));
        promises.push(this.CoreCompanyService.getCurrent(true));

        return new Promise((resolve, reject) => {
            this.$q.all(promises).then(res => {
                let companyId = res[1]._id;

                var blandQuery = {
                    filters: [],
                    q: '',
                    page: 0,
                    pageSize: 0,
                    language: this.CoreUserService.getLanguage()
                },
                    queryForAllContacts = angular.copy(blandQuery),
                    queryForAllSources = angular.copy(blandQuery),
                    promises = [];

                // Stop if we've already got a cached all aggs from the same company
                if (this.cachedAllAggs && this.cachedAllAggs.companyId && this.cachedAllAggs.companyId === companyId) {

                    this.setDefaultMapView(this.getCountriesList(), this.countryMapping);
                    resolve(this.cachedAllAggs);
                    return;
                }

                queryForAllContacts.aggregations = this.defaultAggs.contact;
                queryForAllSources.aggregations = this.defaultAggs.source;

                promises.push(this.InfluencerContactService.aggregateContactSearch(queryForAllContacts));
                promises.push(this.InfluencerContactService.aggregateSourceSearch(queryForAllSources));

                this.$q.all(promises).then(result => {
                    var contactsResponse = result[0],
                        sourcesResponse = result[1];

                    // setup the languages
                    if (contactsResponse.aggs && contactsResponse.aggs.languages) {
                        contactsResponse.aggs.languages = this.mapLanguage(contactsResponse.aggs.languages);
                    }
                    if (sourcesResponse.aggs && sourcesResponse.aggs.languages) {
                        sourcesResponse.aggs.languages = this.mapLanguage(sourcesResponse.aggs.languages);
                    }

                    // setup the reaches
                    if (contactsResponse.aggs && contactsResponse.aggs.sourcesReachTiers) {
                        contactsResponse.aggs.sourcesReachTiers = this.mapReaches(contactsResponse.aggs.sourcesReachTiers);
                    }
                    if (sourcesResponse.aggs && sourcesResponse.aggs.reachTiers) {
                        sourcesResponse.aggs.reachTiers = this.mapReaches(sourcesResponse.aggs.reachTiers);
                    }

                    this.cachedAllAggs = {
                        contact: contactsResponse.aggs,
                        source: sourcesResponse.aggs,
                        companyId: companyId,
                        userLanguage: this.userLanguage
                    };
                    this.PageStateService.setItem('allAggs', this.cachedAllAggs, this.LOCKER_NAMESPACE);
                    this.setDefaultMapView(this.getCountriesList(), this.countryMapping);
                    resolve(this.cachedAllAggs);

                }).catch(error => reject(error));
            });
        });
    };

    // Only load the aggs. Good for initial load and searchType change
    SearchControllerV2.prototype.loadAggsOnly = function loadAggsOnly() {
        return this.$q(function (resolve) {

            // we dont want the content stream to flash
            this.pageState.hideStream = true;

            this.searchForNonRelevantFilterOptions().then(allAggs => {
                if (!this.pageState.isContactSearch) {
                    this.updateFiltersBasedOnAggs(allAggs.source);
                    resolve(allAggs.source);
                } else {
                    this.updateFiltersBasedOnAggs(allAggs.contact);
                    resolve(allAggs.contact);
                }
            })
                .catch(function () { });
        }.bind(this));
    };

    SearchControllerV2.prototype.mapLanguage = function mapLanguage(languages) {
        return languages.map(function (language) {
            var languageObject = this.IcmLanguageService.getLanguage(language.key);
            if (languageObject) {
                language.name = languageObject.name;
            }
            else {
                language.name = language.key;
            }
            return language;
        }.bind(this));
    };

    SearchControllerV2.prototype.mapReaches = function mapReaches(reaches) {
        return reaches.map(function (reachTier) {
            reachTier.name = reachTier.display;
            return reachTier;
        }.bind(this));
    };

    SearchControllerV2.prototype.updatePageView = function updatePageView(searchText, searchChipsLength, filterLength, listStatusFilterActive, totalResults) {
        totalResults = (totalResults > -1) ? totalResults : 0;

        if(_.findIndex(this.queryFilters, {type: 'viewport'} )> -1){
            this.$rootScope.$broadcast('updateTotalCount', { itemCount: totalResults });
        }
    };

    SearchControllerV2.prototype.searchRelevantContactsUntilResults = function searchRelevantContactsUntilResults(query, resolve) {
        var currentIndex,
            arrayLength,
            _this = this;

        let searchStartTime = this.moment.utc();
        this.relevantSearchLoading = true;
        this.ContactStreamDataForRelevant.aggregateRelevantContacts(query).then(function (response) {
            // update filters if there are aggs
            if (response) {
                if (response.aggs) {
                    this.pageState.relevantAggs = response.aggs;
                    this.updateAllAggs();
                }

                var totalContacts = response.hits && response.hits.length ? this.ContactStreamDataForRelevant.totalContacts : 0;

                this.trackSearch('relevantContact', query, totalContacts);
                this.trackSearchSuccessCloudwatch('relevantContact', searchStartTime);
            } else {
                this.DialogService.flashError(this.$translate.instant('Error. There was a problem with your request. Please try again later.'));
            }

            arrayLength = this.datePickerOptions.length;
            if (this.ContactStreamDataForRelevant.totalContacts > 0 || (this.datePickerOptions[arrayLength - 1].value === this.pageState.dateRangeDays)) {
                if(this.ContactStreamDataForRelevant.totalContacts < 1){
                    this.ContactStreamDataForRelevant.resetSearch();
                }
                this.relevantSearchLoading = false;
                this.setPageState();
                resolve();
            } else {
                this.datePickerOptions.some(function (obj, i) {
                    return obj.value === this.pageState.dateRangeDays ? (currentIndex = i, true) : false;
                }.bind(this));

                let selectDateWithIndex = ((!!this.datePickerOptions[currentIndex + 1]) ? (currentIndex + 1) : (currentIndex));

                this.pageState.dateRangeDays = this.datePickerOptions[selectDateWithIndex].value;
                this.pageState.selectedDateRange = this.datePickerOptions[selectDateWithIndex].materialSyntax;

                query.docQuery.dateStart = this.moment().tz(this.ICMUserService.getTimezone()).subtract(this.pageState.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString();
                this.locationsFilter.updateQuery(this.pageState.searchText, query.filters, this.pageState.currentSearchType, query.orQ, this.pageState.dateRangeDays);
                this.searchRelevantContactsUntilResults(query, resolve);
            }
        }.bind(this)).catch(function () {
            _this.trackSearchFailedCloudwatch('relevantContact', searchStartTime);
        });
    };

    SearchControllerV2.prototype.searchRelevantSourcesUntilResults = function searchRelevantSourcesUntilResults(query, resolve) {
        var currentIndex,
            arrayLength,
            _this = this;

        let searchStartTime = this.moment.utc();
        this.relevantSearchLoading = true;
        this.SourceStreamDataForRelevant.aggregateRelevantSources(query).then(function (response) {
            // update filters if there are aggs
            if (response) {
                if (response.aggs) {
                    this.pageState.relevantAggs = response.aggs;
                    this.updateAllAggs();
                }

                var totalSources = response.hits && response.hits.length ? this.SourceStreamDataForRelevant.totalSources : 0;

                this.trackSearch('relevantSource', query, totalSources);
                this.trackSearchSuccessCloudwatch('relevantSource', searchStartTime);
            }
            else {
                this.DialogService.flashError(this.$translate.instant('Error. There was a problem with your request. Please try again later.'));
            }

            arrayLength = this.datePickerOptions.length;
            if (this.SourceStreamDataForRelevant.totalSources > 0 || (this.datePickerOptions[arrayLength - 1].value === this.pageState.dateRangeDays)) {
                if(this.SourceStreamDataForRelevant.totalSources < 1){
                    this.SourceStreamDataForRelevant.resetSearch();
                }
                this.relevantSearchLoading = false;
                this.setPageState();
                resolve();
            } else {
                this.datePickerOptions.some(function (obj, i) {
                    return obj.value === this.pageState.dateRangeDays ? (currentIndex = i, true) : false;
                }.bind(this));
                this.pageState.dateRangeDays = this.datePickerOptions[currentIndex + 1].value;
                query.docQuery.dateStart = this.moment().tz(this.ICMUserService.getTimezone()).subtract(this.pageState.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString();
                this.locationsFilter.updateQuery(this.pageState.searchText, query.filters, this.pageState.currentSearchType, query.orQ, this.pageState.dateRangeDays);
                this.searchRelevantSourcesUntilResults(query, resolve);
            }
        }.bind(this)).catch(function () {
            _this.trackSearchFailureCloudwatch('relevantSource', searchStartTime);
        });
    };

    SearchControllerV2.prototype.scrollToTop = function scrollToTop() {
        var scrollContainerElement = angular.element('md-content.mw-flex-padding'),
            y = scrollContainerElement.scrollTop();
        if (y > 308) {
            this.$timeout(function() {
                if (scrollContainerElement.length) {
                    scrollContainerElement.animate(
                        { scrollTop: 308 },
                        { duration: 600 }
                    );
                }
            }, 0);
        }
    };

    SearchControllerV2.prototype.searchNamed = function() {
        if (this.pageState.isRelevantSelected === true) {
            this.scrollToTop();
        }

        this.MiniProfileService.closeMiniProfile();
        this.pageState.miniProfileContactId = '';


        this.pageState.isRelevantSelected = false;
        this.activeSearchTab = this.NAME_SEARCH_TAB;

        this.updateChipSummary(this.pageState.searchChips);
        if(this.pageState.isContactSearch){
            this.setSearchType(this.pageState.searchTypeOptions[0]);
        } else if(!this.pageState.isContactSearch){
            this.setSearchType(this.pageState.searchTypeOptions[2]);
        }
        this.setPageState();
    };

    SearchControllerV2.prototype.searchWritingAbout = function() {
        if (this.pageState.isRelevantSelected === false) {
            this.scrollToTop();
        }

        this.MiniProfileService.closeMiniProfile();
        this.pageState.miniProfileContactId = '';

        this.pageState.isRelevantSelected = true;
        this.activeSearchTab = this.RELEVANT_SEARCH_TAB;

        this.updateChipSummary(this.pageState.searchChips);
        if(this.pageState.isContactSearch){
            this.setSearchType(this.pageState.searchTypeOptions[1]);

        } else if(!this.pageState.isContactSearch){
            this.setSearchType(this.pageState.searchTypeOptions[3]);
        }
        this.setPageState();
    };

    SearchControllerV2.prototype.searchForBoth = function(keepMiniOpen = false){
        if (!keepMiniOpen) {
            this.MiniProfileService.closeMiniProfile();
            this.pageState.pageRefresh = false;
            this.pageState.miniProfileContactId = '';
        }
        this.setPageState();

        var promiseArray = [];
        return this.$q(resolve => {
            if(this.pageState.isContactSearch){
                promiseArray.push(this.searchDifferent(this.pageState.searchText, this.pageState.searchChips, null, this.pageState.searchTypeOptions[0].type));
                promiseArray.push(this.searchDifferent(this.pageState.searchText, this.pageState.searchChips, null, this.pageState.searchTypeOptions[1].type));
            } else {
                promiseArray.push(this.searchDifferent(this.pageState.searchText, this.pageState.searchChips, null, this.pageState.searchTypeOptions[2].type));
                promiseArray.push(this.searchDifferent(this.pageState.searchText, this.pageState.searchChips, null, this.pageState.searchTypeOptions[3].type));
            }

            this.$q.all(promiseArray).then(() =>{
                // check to make sure we didn't overlap relevant searches with no search text searches resulting in the writing about tab having results when it shouldn't
                if(!this.relevantQuery.relevantQ.length && !this.relevantQuery.orQ.length){
                    if(this.pageState.isContactSearch){
                        this.ContactStreamDataForRelevant.resetSearch();
                    } else {
                        this.SourceStreamDataForRelevant.resetSearch();
                    }
                }
                this.totalContacts = (this.ContactStreamDataForNames.totalContacts > -1 ? this.ContactStreamDataForNames.totalContacts : 0) + (this.ContactStreamDataForRelevant.totalContacts > -1 ? this.ContactStreamDataForRelevant.totalContacts : 0);
                let totalSources = (this.SourceStreamDataForNames.totalSources > -1 ? this.SourceStreamDataForNames.totalSources : 0) + (this.SourceStreamDataForRelevant.totalSources > -1 ? this.SourceStreamDataForRelevant.totalSources : 0);

                if(this.pageState.isContactSearch && !this.pageState.hideStream) {
                    this.updatePageView(this.pageState.searchText, this.pageState.searchChips.length, [], false, this.totalContacts);
                } else {
                    this.updatePageView(this.pageState.searchText, this.pageState.searchChips.length, [], false, totalSources);
                }

                resolve();
            });
        });
    };

    SearchControllerV2.prototype.updateAllAggs = function(){
        let allAggs = this.combineAggregations(this.pageState.namedAggs, this.pageState.relevantAggs);
        this.updateFiltersBasedOnAggs(allAggs);
    };

// loading logic for synced streams and independent searches
    SearchControllerV2.prototype.loadingContentStreams = function() {
        if(this.pageState.isContactSearch){
            if(!this.pageState.isRelevantSelected){
                if(this.ContactStreamDataForNames.isSearching && this.independentSearch){
                    return true;
                } else {
                    return (!this.independentSearch && (this.ContactStreamDataForRelevant.isSearching || this.ContactStreamDataForNames.isSearching ));
                }
            } else if (this.pageState.isRelevantSelected) {
                if(this.ContactStreamDataForRelevant.isSearching && this.independentSearch){
                    return true;
                } else {
                    return (!this.independentSearch && (this.ContactStreamDataForRelevant.isSearching || this.ContactStreamDataForNames.isSearching ));
                }
            }
        } else if (!this.pageState.isContactSearch){
            if(!this.pageState.isRelevantSelected){
                if(this.SourceStreamDataForNames.isSearching && this.independentSearch){
                    return true;
                } else {
                    return (!this.independentSearch && (this.SourceStreamDataForRelevant.isSearching || this.SourceStreamDataForNames.isSearching ));
                }
            } else if (this.pageState.isRelevantSelected) {
                if(this.SourceStreamDataForRelevant.isSearching && this.independentSearch){
                    return true;
                } else {
                    return (!this.independentSearch && (this.SourceStreamDataForRelevant.isSearching || this.SourceStreamDataForNames.isSearching ));
                }
            }
        }
        return false;
    };

    SearchControllerV2.prototype.showContentStreamHeader = function() {
        if(this.pageState.isContactSearch){
            if((!this.pageState.isRelevantSelected && this.ContactStreamDataForNames.isSearching && this.independentSearch) || (this.pageState.isRelevantSelected && this.ContactStreamDataForRelevant.isSearching && this.independentSearch)){
                return true;
            } else if (!this.independentSearch && (this.ContactStreamDataForNames.isSearching || this.ContactStreamDataForRelevant.isSearching) ){
                return false;
            }
        } else if(!this.pageState.isContactSearch)  {
            if((!this.pageState.isRelevantSelected && this.SourceStreamDataForNames.isSearching && this.independentSearch) || (this.pageState.isRelevantSelected && this.SourceStreamDataForRelevant.isSearching && this.independentSearch)){
                return true;
            } else if (!this.independentSearch && (this.SourceStreamDataForNames.isSearching || this.SourceStreamDataForRelevant.isSearching) ){
                return false;
            }
        }
        return true;
    };

    SearchControllerV2.prototype.showNamedTabCount = function() {
        if(this.pageState.isContactSearch){
            if(this.ContactStreamDataForNames.isSearching && this.independentSearch){
                return true;
            } else {
                return (!this.independentSearch && (this.ContactStreamDataForRelevant.isSearching || this.ContactStreamDataForNames.isSearching ));
            }
        } else if(!this.pageState.isContactSearch)  {
            if(this.SourceStreamDataForNames.isSearching && this.independentSearch){
                return true;
            } else {
                return (!this.independentSearch && (this.SourceStreamDataForRelevant.isSearching || this.SourceStreamDataForNames.isSearching ));
            }
        }
    };

    SearchControllerV2.prototype.showRelevantTabCount = function() {
        if(this.pageState.isContactSearch){
            if(this.ContactStreamDataForRelevant.isSearching && this.independentSearch){
                return true;
            } else {
                return (!this.independentSearch && (this.ContactStreamDataForRelevant.isSearching || this.ContactStreamDataForNames.isSearching ));
            }
        } else if (!this.pageState.isContactSearch) {
            if(this.SourceStreamDataForRelevant.isSearching && this.independentSearch){
                return true;
            } else {
                return (!this.independentSearch && (this.SourceStreamDataForRelevant.isSearching || this.SourceStreamDataForNames.isSearching ));
            }
        }
    };

    SearchControllerV2.prototype.showContactStream = function(){
        let show = false;
        if(!this.pageState.hideStream && this.pageState.isContactSearch){
            show = this.pageState.isRelevantSelected ? (this.ContactStreamDataForRelevant.totalContacts > 0 || this.loadingContentStreams()) : (this.ContactStreamDataForNames.totalContacts > 0 || this.loadingContentStreams());
        }
        return show;
    };

    SearchControllerV2.prototype.showSourceStream = function(){
        let show = false;
        if(!this.pageState.hideStream && !this.pageState.isContactSearch){

            show = this.pageState.isRelevantSelected ? (this.SourceStreamDataForRelevant.totalSources > 0 || this.loadingContentStreams()) : (this.SourceStreamDataForNames.totalSources > 0 || this.loadingContentStreams());
        }
        return show;
    };

    SearchControllerV2.prototype.searchDifferent = function search(searchText, searchChips, aggregations, searchType, independent) {
            var _this = this;
            this.pageState.forceShowFilters = true;
            this.allFiltersWaitOnSearch();
            if (!searchChips) {
                searchChips = [];
            }
            this.independentSearch = independent || false;
            this.clearDetectedBeats();
            return this.$q(resolve => {
                this.buildSearchQuery(searchText, searchChips, aggregations, undefined, searchType).then(query => {
                    this.resetSelections();
                    this.locationsFilter.updateQuery(searchText, query.filters, searchType, getSearchChipValues(searchChips), this.pageState.dateRangeDays);

                    // Add the find filter content from the prediction panel and modify the query accordingly
                    query = this.buildFindFilterQuery(searchType, query);
                    this.queryFilters = query.filters;
                    this.pageState.hideStream = (!searchText && !query.filters.length && !query.listStatus && (searchChips && searchChips.length === 0));
                    this.pageState.emptyState = this.pageState.hideStream;

                    if (searchType === 'source') {
                        this.nameSearchLoading = true;
                        this.pageState.sourceSearchTerms = query.q;

                        let searchStartTime = this.moment.utc();
                        this.SourceStreamDataForNames.aggregateSearch(query).then(function (response) {
                            if (response) {
                                // check named searches to make sure the count and hits are in sync when the search returns nothing
                                if(this.SourceStreamDataForNames.totalSources === 0){
                                    this.SourceStreamDataForNames.resetSearch();
                                }
                                resolve(response);
                                if (response.aggs) {
                                    this.pageState.namedAggs = response.aggs;
                                    this.updateAllAggs();
                                }
                                this.trackSearch(searchType, query, this.SourceStreamDataForNames.totalSources);
                                this.trackSearchSuccessCloudwatch(searchType, searchStartTime);

                            }
                            else {
                                this.DialogService.flashError(this.$translate.instant('Error. There was a problem with your request. Please try again later.'));
                                resolve();
                            }
                            this.nameSearchLoading = false;
                            this.setPageState();
                            resolve();
                        }.bind(this)).catch(function () {
                            _this.trackSearchFailureCloudwatch(searchType, searchStartTime);
                        });
                    }
                    else if (searchType === 'contact') {
                        this.nameSearchLoading = true;
                        this.pageState.searchText = query.q;

                        let searchStartTime = this.moment.utc();
                        this.ContactStreamDataForNames.aggregateSearch(query).then(function (response) {
                            if (response) {
                                // check named searches to make sure the count and hits are in sync when the search returns nothing
                                if(this.ContactStreamDataForNames.totalContacts === 0){
                                    this.ContactStreamDataForNames.resetSearch();
                                }
                                  resolve(response);
                                if (response.aggs) {
                                    this.pageState.namedAggs = response.aggs;
                                    this.updateAllAggs();
                                }
                                this.trackSearch(searchType, query, this.ContactStreamDataForNames.totalContacts);
                                this.trackSearchSuccessCloudwatch(searchType, searchStartTime);
                            }
                            else {
                                this.DialogService.flashError(this.$translate.instant('Error. There was a problem with your request. Please try again later.'));
                                resolve();
                            }
                            this.nameSearchLoading = false;
                            this.setPageState();
                            resolve();
                        }.bind(this)).catch(function () {
                            _this.trackSearchFailureCloudwatch(searchType, searchStartTime);
                        });
                    }
                    else if (searchType === 'relevantContact') {
                        this.pageState.searchText = query.relevantQ;
                        query.docQuery = {};
                        query.docQuery.dateStart = this.moment().tz(this.ICMUserService.getTimezone()).subtract(this.pageState.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString();
                        query.docQuery.dateEnd = this.moment().tz(this.ICMUserService.getTimezone()).endOf('day').toISOString();
                        this.relevantQuery = query;
                        if ((query.relevantQ.length || query.orQ.length) && !((query.relevantQ.length === 1 && query.relevantQ[0].length < 3) || (query.orQ.length === 1 && query.orQ[0].length < 3))){
                            this.searchRelevantContactsUntilResults(query, resolve);
                        } else {
                            this.ContactStreamDataForRelevant.resetSearch();
                            this.pageState.noResults = false;
                            if(!searchText && !query.filters.length && !query.listStatus && (searchChips && searchChips.length === 0)){
                                this.pageState.emptyState = true;
                            }
                            this.setPageState();
                            resolve();
                        }
                    }
                    else if (searchType === 'relevantSource') {
                        this.pageState.sourceSearchTerms = query.relevantQ;
                        query.docQuery = {};
                        query.docQuery.dateStart = this.moment().tz(this.ICMUserService.getTimezone()).subtract(this.pageState.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString();
                        query.docQuery.dateEnd = this.moment().tz(this.ICMUserService.getTimezone()).endOf('day').toISOString();
                        this.relevantQuery = query;
                        if ((query.relevantQ.length || query.orQ.length) && !((query.relevantQ.length === 1 && query.relevantQ[0].length < 3) || (query.orQ.length === 1 && query.orQ[0].length < 3))) {
                             this.searchRelevantSourcesUntilResults(query, resolve);
                         } else {
                             this.SourceStreamDataForRelevant.resetSearch();
                             this.pageState.noResults = false;
                             if(!searchText && !query.filters.length && !query.listStatus && (searchChips && searchChips.length === 0)){
                                 this.pageState.emptyState = true;
                             }
                             this.setPageState();
                             resolve();
                         }
                    }
                    this.pageState.previousQuery = this.previousQuery = query;
                    this.pageState.searchText = searchText;
                });
            });
        };

    /*
     ----------------------------------
     -------- Page Functions ---------
     ----------------------------------
     */

    SearchControllerV2.prototype.setPageState = function setPageState() {
        try {
            this.PageStateService.set(this.$location.search().locker, this.pageState, this.LOCKER_NAMESPACE);
        } catch (e) {
            //Clean the namespace up when we're full and try again.
            this.PageStateService.cleanLockerNamespace(this.LOCKER_NAMESPACE);
            this.PageStateService.setItem('allAggs', this.cachedAllAggs, this.LOCKER_NAMESPACE);
            this.PageStateService.set(this.$location.search().locker, this.pageState, this.LOCKER_NAMESPACE);
        }

    };

    SearchControllerV2.prototype.nextPageContacts = function nextPageContacts(contentStream) {
        contentStream.nextPage().then(function () {
            if (this.ContactSelectorForNames.allSelected && contentStream.contactArray.length > 25) {
                this.ContactSelectorForNames.selectAllForNextPage(contentStream.contactArray);
            }

            if (this.ContactSelectorForRelevant.allSelected && contentStream.contactArray.length > 25) {
                this.ContactSelectorForRelevant.selectAllForNextPage(contentStream.contactArray);
            }

        }.bind(this))
            .catch(function () { });
    };

    SearchControllerV2.prototype.nextPageSources = function nextPageSources(stream) {
        stream.nextPage();
    };

    /*
     ---------------------------------------------
     -------- Search Type Card Functions ---------
     ---------------------------------------------
     */
    SearchControllerV2.prototype.setSearchType = function setSearchType(newlySelected) {
        // find the already selected one and set it to be unselected
        if (!newlySelected) {
            newlySelected = this.pageState.searchTypeOptions[0];
        }
        else if (this.pageState.searchTypeOptions[indexOf('selected', true, this.pageState.searchTypeOptions)]) {
            var previouslySelected = this.pageState.searchTypeOptions[indexOf('selected', true, this.pageState.searchTypeOptions)];

            // set it to unselected
            previouslySelected.selected = false;
        }

        // set the newly selected search type
        newlySelected.selected = true;

        if (newlySelected.type.toLowerCase().indexOf('contact') >= 0) {
            this.pageState.isContactSearch = true;
        } else {
            this.pageState.isContactSearch = false;
        }

        // Kick this off for each search type change,
        this.insertNonRelevantFilterOptions();

        this.updateChipSummary(this.pageState.searchChips);
    };

    SearchControllerV2.prototype.selectInfluencers = function selectInfluencers() {
        this.setSearchType(this.pageState.searchTypeOptions[0]);
        this.showSearchDropDown = false;

        this.pageState.isRelevantSelected = false;
        this.activeSearchTab = this.NAME_SEARCH_TAB;
    };

    SearchControllerV2.prototype.selectRelevantInfluencers = function selectRelevantInfluencers() {
        this.setSearchType(this.pageState.searchTypeOptions[1]);
        this.pageState.dateRangeDays = this.datePickerOptions[0].value;
        this.resetMaterialDatePicker();

        this.pageState.isRelevantSelected = true;
        this.activeSearchTab = this.RELEVANT_SEARCH_TAB;
    };

    SearchControllerV2.prototype.selectSources = function selectSources() {
        this.setSearchType(this.pageState.searchTypeOptions[2]);
        this.showSearchDropDown = false;

        this.pageState.isRelevantSelected = false;
        this.activeSearchTab = this.NAME_SEARCH_TAB;
    };

    SearchControllerV2.prototype.selectRelevantSources = function selectRelevantSources() {
        this.setSearchType(this.pageState.searchTypeOptions[3]);
        this.pageState.dateRangeDays = this.datePickerOptions[0].value;
        this.resetMaterialDatePicker();

        this.pageState.isRelevantSelected = true;
        this.activeSearchTab = this.RELEVANT_SEARCH_TAB;
    };

    SearchControllerV2.prototype.getSelectedSearchType = function getSelectedSearchType() {
          if(this.pageState.isRelevantSelected){
                if(this.pageState.isContactSearch){
                    return this.pageState.searchTypeOptions[1].type;
                } else {
                    return this.pageState.searchTypeOptions[3].type;
                }
          } else {
                if(this.pageState.isContactSearch){
                    return this.pageState.searchTypeOptions[0].type;
                } else {
                    return this.pageState.searchTypeOptions[2].type;
                }
          }
    };

    SearchControllerV2.prototype.showSwitchSearchTypeModal = function showSwitchSearchTypeModal(event) {
        var titleText = this.$translate.instant('icm-search__switch-to-source-search--confirm-box-title'),
            bodyText = this.$translate.instant('icm-search__switch-to-source-search--confirm-box-body');
        if (!this.pageState.isContactSearch) {
            titleText = this.$translate.instant('icm-search__switch-to-contact-search--confirm-box-title');
            bodyText = this.$translate.instant('icm-search__switch-to-contact-search--confirm-box-body');
        }

        this.$mdDialog.show(
            this.$mdDialog.mwMiniModal()
                .class('switch-search-type-modal')
                .title(titleText)
                .textContent(bodyText)
                .ok(this.$translate.instant('OK'))
                .cancel(this.$translate.instant('action-label__cancel'))
                .targetEvent(event)
        ).then(
            function okHandler() {
                if (!this.pageState.isContactSearch) {
                    this.selectInfluencers();
                }
                else {
                    this.selectSources();
                }
                this.clearAll();
            }.bind(this),
            function cancelHandler() { }
        ).finally(
            function () {
                var settings = {};
                if (this.contactSettings) {
                    settings = this.contactSettings;
                }
                settings.showSearchSwitchModal = false;
                this.ICMUserService.setAppSettings('contacts', settings);
            }.bind(this));
    };

    SearchControllerV2.prototype.switchSearchTypeShortCut = function switchSearchTypeShortCut(event) {
        var showSearchModal = true;
        this.activeSearchTab = this.NAME_SEARCH_TAB;

         if (this.contactSettings && this.contactSettings.showSearchSwitchModal === false) {
            showSearchModal = false;
         }

         if (showSearchModal) {
            this.showSwitchSearchTypeModal(event);
         } else {
            if(this.pageState.isContactSearch) {
                this.selectSources();
            } else {
                this.selectInfluencers();
            }
            this.clearAll();
         }
    };


    SearchControllerV2.prototype.switchSearchTypeDropDown = function switchSearchTypeDropDown(event) {
        var showSearchModal = true;

        if (this.contactSettings && this.contactSettings.showSearchSwitchModal === false) {
            showSearchModal = false;
        }

        if (showSearchModal) {
            this.showSwitchSearchTypeModal(event);
        } else {
            // setup to detect drop down goes blur
            angular.element(document).click(function ($event) {
                if (this.showSearchDropDown) {
                    this.showSearchDropDown = false;
                }
                this.$timeout(function () {
                    angular.element(document).off('click');
                }, 100);
                $event.stopPropagation();
            }.bind(this));

            // toggle drop down
            this.showSearchDropDown = !this.showSearchDropDown;
            event.stopPropagation();
        }
    };

    SearchControllerV2.prototype.openSampleMiniModal = function openSampleMiniModal(event) {
          var titleText = this.$translate.instant('icm-search__sample-miniModal--title'),
            bodyText = this.$translate.instant('icm-search__sample-miniModal--contact-search-msg');
        if (!this.pageState.isContactSearch) {
            bodyText = this.$translate.instant('icm-search__sample-miniModal--source-search-msg');
        }

        this.$mdDialog.show(
            this.$mdDialog.mwMiniModal({
                locals: {
                    title: titleText,
                    body: bodyText
                },
                templateUrl: 'icm-web/views/search_sample_mini_modal',
                controllerAs: '$ctrl'
            }).targetEvent(event)
        ).then(
            function okHandler() {
                if (!this.pageState.isContactSearch) {
                    this.initializeSourceSampleSearch();
                } else {
                    this.initializeContactSampleSearch();
                }
            }.bind(this),
            function cancelHandler() {
                //'You selected cancel'
            }
        ).catch(function () { });
    };

    SearchControllerV2.prototype.openHelpCenter = function openHelpCenter() {
        this.$window.open('https://help.meltwater.com/');
    };

    SearchControllerV2.prototype.gotoMediaResearchHelp = function gotoMediaResearchHelp() {
        this.$window.open('https://help.meltwater.com/en/articles/4064620-how-to-do-media-research-in-meltwater-to-discover-relevant-influencers-and-publications');
    };

    SearchControllerV2.prototype.getAllSelectedFilterOptionsForTracking = function getAllSelectedFilterOptionsForTracking(searchType) {
        var filterNames,
            filterSelection,
            realNames = [],
            selectedOptions = [];

        if (!searchType) {
            return [];
        }

          if(this.pageState.isContactSearch) {
            filterNames = [
                'locationsFilter',
                'sourcesFilter',
                'beatsFilter',
                'languagesFilter',
                'newsFocusesFilter',
                'frequenciesFilter',
                'reachesFilter',
                'mediaChannelsFilter',
                'rolesFilter',
                'emailsFilter',
                'listStatusFilter'
            ];
        } else {
            filterNames = [
                'locationsFilter',
                'beatsFilter',
                'languagesFilter',
                'newsFocusesFilter',
                'frequenciesFilter',
                'reachesFilter',
                'mediaChannelsFilter'
            ];
        }

        filterNames.forEach(function (filterName) {
            if (this[filterName].getSelectedCount() > 0) {
                filterSelection = this[filterName].selectionFactory.getSelection();
                for (var selection in filterSelection) {
                    if (filterSelection.hasOwnProperty(selection)) {
                        if (filterSelection[selection].name) {
                            realNames.push(filterSelection[selection].name);
                        }
                        else {
                            realNames.push(filterSelection[selection].display);
                        }
                    }
                }
                selectedOptions.push(filterName.replace('Filter', '') + ':' + realNames.join(','));
                realNames = [];
            }
        }.bind(this));

        if (this.mapView && this.MapService.getViewportBounds() && this.pageState.mapActive) {
            selectedOptions.push('mapZoom:' + this.MapService.map.getZoom());
        }

        return selectedOptions.join('|');
    };

    /*
     ----------------------------------
     -------- Relevant Articles ---------
     ----------------------------------
     */

    SearchControllerV2.prototype.showRelevantArticles = function showRelevantArticles(type, itemObject, event) {
        var relevantArticlesSettings = {},
            userSearchSettings = this.contentStreamSettings,
            defaultSettings = {
                avatar: true,
                displayTags: true,
                groupOption: 'none',
                hitSentence: true,
                images: true,
                keywords: true,
                openingText: true
            },
            query = {
                'name': null,
                'allKeywords': (this.pageState.searchText.length > 0) ? [this.pageState.searchText] : getSearchChipValues(this.pageState.searchChips),
                'anyKeywords': [],
                'notKeywords': [],
                'booleanQuery': null,
                'informationTypes': ['news', 'tender'],
                'dateStart': this.moment().tz(this.ICMUserService.getTimezone()).subtract(this.pageState.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString(),
                'dateEnd': this.moment().tz(this.ICMUserService.getTimezone()).endOf('day').toISOString(),
                'searchQueryType': 'keyword',
                'page': 1,
                'pageSize': 25,
                'groupOption': 'none',
                'caseSensitive': 'no',
                'sortField': 'date',
                'sortOrder': 'DESC',
                'useDateQueryStart': true,
                'showHiddenDocuments': false,
                'listStart': 0,
                'listSize': 0,
                'usePageAsOffset': false,
                'groupFrom': 0,
                'dateQueryStart': this.moment().tz(this.ICMUserService.getTimezone()).endOf('day').toISOString(),
                'searchQueryId': null,
                'childIds': itemObject.childIds || []
            };

        // setting default values if not exists
        angular.extend(relevantArticlesSettings, defaultSettings, userSearchSettings);

        this.RelevantArticlesDialogService.showDialog(query, itemObject, '', relevantArticlesSettings, type, event);
    };

    /*
        ----------------------------------
        ------ Media List Functions ------
        ----------------------------------
    */
    SearchControllerV2.prototype.tagSelectedContacts = function tagSelectedContacts(contactSelector, contactStream) {
        var queryType = null,
            searchType = this.getSelectedSearchType();

        // need to build a search query w/the find filter
        if (contactSelector.trueAllSelected) {
            queryType = ((searchType === 'relevantContact' && this.pageState.chipsHaveSearchTerms) ? 'searchRelevantContact' : 'searchContact');

            return this.buildSearchQuery(this.pageState.searchText, this.pageState.searchChips, [], contactStream.totalContacts).then(query => {
                query = this.buildFindFilterQuery(searchType, query);

                if (queryType === 'searchRelevantContact') {
                    query.docQuery = {
                        dateStart: this.moment().tz(this.ICMUserService.getTimezone()).subtract(this.pageState.dateRangeDays, 'days').add(1, 'days').startOf('day').toISOString(),
                        dateEnd: this.moment().tz(this.ICMUserService.getTimezone()).endOf('day').toISOString()
                    };
                }
                return query;
            }).then(query => {
                this.openTagDialog(query, queryType, contactSelector, searchType, contactStream);
            });
        } else {
            this.openTagDialog(null, null, contactSelector, searchType, contactStream);
        }
    };

    function refreshContactStream(){
        window.removeEventListener('icm-list-dialog-on-close', removeDialogEventListeners, {once: true});

        let _this = angular.element(document.getElementsByClassName('searchPage')).scope().searchController;
        _this.resetSelections();
        _this.$scope.$apply();
    }

    function removeDialogEventListeners(){
        window.removeEventListener('icm-lists-updated', refreshContactStream, {once: true});
    }

    SearchControllerV2.prototype.openTagDialog = function openTagDialog(query = null, queryType = null, contactSelector, searchType, contactStream) {
        window.addEventListener('icm-lists-updated', refreshContactStream, {once: true});
        window.addEventListener('icm-list-dialog-on-close', removeDialogEventListeners, {once: true});

        let selectedContactIds = Object.keys(contactSelector.selectedItems);
        let manageListDialog = document.querySelector('icm-manage-lists-dialog');

        if(contactSelector.trueAllSelected && contactStream.totalContacts > this.MAX_MEDIALIST_LIMIT || contactSelector.selectedItems > this.MAX_MEDIALIST_LIMIT) {
            let manageListLimitWarning = document.querySelector('manage-list-limit-warning');
            manageListLimitWarning.open();
        } else if (contactSelector.trueAllSelected) {
            query.page = 0;
            query.pageSize = this.MAX_MEDIALIST_LIMIT;
            query.onlyIds = true;
            var request = {
                method: 'POST',
                url: '',
                data: query
            };
            if(searchType.includes('relevant')){
                request.url = this.ICM_CSS_URL + '/search/relevantContacts';
            } else {
                request.url = this.ICM_CSS_URL + '/search/contacts';
            }
            manageListDialog.openLoading();

            this.$http(request).then((response) => {
                manageListDialog.open(response.data);
            }).catch(function(err) {
                manageListDialog.showLoadingErrorState();
                this.reject(err.data);
            });

        } else {
            manageListDialog.open(selectedContactIds);
        }
    };

    SearchControllerV2.prototype.resetChipSummary = function resetChipSummary() {
        this.pageState.relevantChipSummary = '';
        this.pageState.namedChipSummary = '';
        this.pageState.chipsHaveSearchTerms = false;
    };

    SearchControllerV2.prototype.updateChipSummary = function updateChipSummary(searchChips) {
        var relevantJoinText = '',
            nameJoinText = '';

        this.pageState.chipsHaveSearchTerms = ((getSearchChipValues(searchChips).length > 0) ? true : false);

        if (searchChips.length > 0) {
            relevantJoinText = this.$translate.instant('icm-search__search-summary--and-query-separator');
            nameJoinText = this.$translate.instant('icm-search__search-summary--or-query-separator');

            this.pageState.relevantChipSummary = searchChips
                .filter(function (searchChip) {
                    return searchChip.type === 'standard';
                })
                .map(function (standardSearchChip) {
                    return ' "' + standardSearchChip.display + '" ';
                })
                .join(relevantJoinText)
                .trim();

            this.pageState.namedChipSummary = searchChips
                .filter(function (searchChip) {
                    return searchChip.type === 'standard';
                })
                .map(function (standardSearchChip) {
                    return ' "' + standardSearchChip.display + '" ';
                })
                .join(nameJoinText)
                .trim();
        } else {
            this.resetChipSummary();
        }
    };

    SearchControllerV2.prototype.translateNamedSearchSummary = function translateSearchSummary(){
        if(this.pageState.isContactSearch){
            return this.$translate.instant('icm-search__duel-streams--named-label', {count: (this.ContactStreamDataForNames.totalContacts > 0 && !this.showNamedTabCount()) ? this.ContactStreamDataForNames.totalContacts : 0});
        } else {
            return this.$translate.instant('icm-search__duel-streams--named-label', {count: (this.SourceStreamDataForNames.totalSources > 0 && !this.showNamedTabCount()) ? this.SourceStreamDataForNames.totalSources : 0});
        }
    };

    SearchControllerV2.prototype.translateRelevantSearchSummary = function translateSearchSummary(){
        if(this.pageState.isContactSearch){
            return this.$translate.instant('icm-search__duel-streams--writing-label', {count: (this.ContactStreamDataForRelevant.totalContacts > 0 && !this.showRelevantTabCount()) ? this.ContactStreamDataForRelevant.totalContacts : 0});
        } else {
            return this.$translate.instant('icm-search__duel-streams--writing-label', {count: (this.SourceStreamDataForRelevant.totalSources > 0 && !this.showRelevantTabCount()) ? this.SourceStreamDataForRelevant.totalSources : 0});
        }
    };

    SearchControllerV2.prototype.searchOnChipChange = function searchOnChipChange(searchChips) {
        this.MiniProfileService.closeMiniProfile();
        this.pageState.miniProfileContactId = '';
        this.setPageState();

        return this.$q(function (resolve) {
            if (searchChips.length > 0 || this.buildSearchFilters().length > 0 || (this.listStatusFilter.getSelectedOption() !== null)) {
                if (this.currentSearchPromise) {
                    this.$timeout.cancel(this.currentSearchPromise);
                }

                this.currentSearchPromise = this.$timeout(() => {
                    this.searchForBoth().then(function() {
                        resolve();
                    })
                        .catch(function () { });
                }, 300);
            } else {
                this.loadAggsOnly();
                resolve();
            }
        }.bind(this));
    };

    SearchControllerV2.prototype.searchChipAdded = function searchChipAdded(executeSearch) {
        this.updateChipSummary(this.pageState.searchChips);

        if (executeSearch) {
            this.searchOnChipChange(this.pageState.searchChips).then(function () {
                this.detectBeats(this.pageState.searchChips);
            }.bind(this))
                .catch(function () { });
        }
        this.setPageState();
    };

    SearchControllerV2.prototype.searchChipRemoved = function searchChipRemoved(removedChip) {
        this.updateChipSummary(this.pageState.searchChips);

        this.searchOnChipChange(this.pageState.searchChips);

        if (removedChip.beat) {
            this.beatsFilter.selectionFactory.deselect(removedChip.beat, true);
        }
    };


    /*
       ----------------------------------
       ------ Did You Mean Functions ------
       ----------------------------------
     */
    SearchControllerV2.prototype.detectBeats = function detectBeats(chipObjects) {
        var _this = this;

        _this.detectedBeats = [];

        function matchBeat(term, beats) {
            beats.some(function (beat) {
                if (beat.display.toLowerCase() === term.toLowerCase()) {
                    _this.detectedBeats.push(beat);
                    return true;
                } else {
                    if (Array.isArray(beat.children) && beat.children.length) {
                        return matchBeat(term, beat.children);
                    } else {
                        return false;
                    }
                }
            });
        }

        if (chipObjects.length) {
            chipObjects.forEach(function (chipObject) {
                if (chipObject.type === 'standard') {
                    matchBeat(chipObject.value, _this.beatsFilter.currentOptions);
                }
            });
        }
    };

    SearchControllerV2.prototype.convertToBeat = function convertToBeat(beat) {
        var standardChipMatchingBeat = -1,
            beatChipAlreadyExists = false;

        this.pageState.searchText = this.pageState.searchText.replace(new RegExp(beat.display, 'gi'), '');
        this.pageState.searchChips.some(function (chipObject, index) {
            if (!chipObject.beat && (chipObject.value.toLowerCase() === beat.display.toLowerCase())) {
                standardChipMatchingBeat = index;
                return true;
            } else {
                return false;
            }
        });

        if (standardChipMatchingBeat >= 0) {
            beatChipAlreadyExists = this.pageState.searchChips.some(function (searchChipObject) {
                return (searchChipObject.beat && (searchChipObject.beat.display.toLowerCase() === beat.display.toLowerCase()));
            });

            if (beatChipAlreadyExists) {
                this.pageState.searchChips.splice(standardChipMatchingBeat, 1);

                this.$mdToast.show(
                    this.$mdToast.mwSimpleTimed().textContent('The beat ' + beat.display + ' was already selected as a filter')
                );
            } else {
                this.pageState.searchChips[standardChipMatchingBeat].type = 'beat';
                this.pageState.searchChips[standardChipMatchingBeat].beat = beat;
                this.pageState.searchChips[standardChipMatchingBeat].display = 'Beat: ' + this.pageState.searchChips[standardChipMatchingBeat].display;

                this.$mdToast.show(
                    this.$mdToast.mwSimpleTimed().textContent('The beat ' + beat.display + ' was added to your filters')
                );

                this.beatsFilter.selectionFactory.select(beat, true);

                this.updateChipSummary(this.pageState.searchChips);
                this.refreshSearch();
            }
        }

        this.focusOnInput();
    };

    SearchControllerV2.prototype.focusOnInput = function focusOnInput() {
        $('md-chips input')[0].focus();
    };

    SearchControllerV2.prototype.clearDetectedBeats = function clearDetectedBeats() {
        this.detectedBeats = [];
    };

    SearchControllerV2.prototype.clearChips = function clearChips() {
        this.pageState.searchText = '';
        this.pageState.searchChips = [];

        this.updateChipSummary(this.pageState.searchChips);
        this.searchOnChipChange(this.pageState.searchChips);
    };

    SearchControllerV2.prototype._trackSearchCloudwatch = function _trackSearchCloudwatch(searchType, searchStartTime, success) {
        let searchTiming = this.moment.utc().diff(searchStartTime, 'milliseconds');

        let metricTimingName = success ? 'SearchSuccessTiming' : 'SearchFailureTiming';
        let metricCountName = success ? 'SearchSuccessCount' : 'SearchFailureCount';

        let listStatusRange = 'NA';
        if (this.listStatusFilter.selectedOption !== null) {
            listStatusRange = 'unknown';

            if(this.allContactsCount > 2500) {
                listStatusRange = '2501+';
            } else if(this.allContactsCount > 2000) {
                listStatusRange = '2001-2500';
            } else if(this.allContactsCount > 1500) {
                listStatusRange = '1501-2000';
            } else if(this.allContactsCount > 1000) {
                listStatusRange = '1001-1500';
            } else if(this.allContactsCount > 500) {
                listStatusRange = '501-1000';
            } else if(this.allContactsCount >= 0) {
                listStatusRange = '0-500';
            }
        }

        let searchTypeDimension = {
            Name: 'SearchType',
            Value: searchType
        };
        let listStatusDimensions = [
            searchTypeDimension,
            {
                Name: 'ListStatusRange',
                Value: listStatusRange
            }
        ];

        let cloudWatchParameters = {
            Namespace: 'icm-web',
            MetricData: [
                // metric to track search timing, excluding list status dimension
                {
                    MetricName: metricTimingName,
                    Value: searchTiming,
                    Unit: 'Milliseconds',
                    Dimensions: [searchTypeDimension]
                },
                // metric to track search count, excluding list status dimension
                {
                    MetricName: metricCountName,
                    Value: 1,
                    Unit: 'Count',
                    Dimensions: [searchTypeDimension]
                },
                // metric to track search timing, including list status dimension
                {
                    MetricName: metricTimingName,
                    Value: searchTiming,
                    Unit: 'Milliseconds',
                    Dimensions: listStatusDimensions
                },
                // metric to track search count, including list status dimension
                {
                    MetricName: metricCountName,
                    Value: 1,
                    Unit: 'Count',
                    Dimensions: listStatusDimensions
                }
            ]
        };

        this.CloudwatchService.cloudwatch.putMetricData(cloudWatchParameters, (error) => {
            if (error) {
                console.error('putMetricData error', error); // jshint ignore:line
            }
        });
    };

    SearchControllerV2.prototype.trackSearchSuccessCloudwatch = function trackSearchSuccessCloudwatch(searchType, searchStartTime) {
        this._trackSearchCloudwatch(searchType, searchStartTime, true);
    };

    SearchControllerV2.prototype.trackSearchFailureCloudwatch = function trackSearchFailureCloudwatch(searchType, searchStartTime) {
        this._trackSearchCloudwatch(searchType, searchStartTime, false);
    };

    SearchControllerV2.prototype.trackSearch = function trackSearch(searchType, query, numberOfResults) { // jshint ignore:line
        var promises = [],
            currentUser,
            currentCompany,
            trackingData = {
                source: 'webapp',
                label: 'icm_search',
                /* jshint ignore:start */
                icm_search_type: searchType,
                icm_search_terms: query.orQ.join('|'),
                icm_search_filter: this.getAllSelectedFilterOptionsForTracking(searchType),
                results_nbr: numberOfResults
                /* jshint ignore: end */
            };

        promises.push(this.CoreUserService.getCurrent(true));
        promises.push(this.CoreCompanyService.getCurrent(true));

        this.$q.all(promises).then(function (responses) {
            currentUser = responses[0];
            currentCompany = responses[1];
            if (query.docQuery && query.docQuery.dateStart && query.docQuery.dateEnd) { // jshint ignore:line
                /* jshint ignore:start */
                trackingData.from_date = query.docQuery.dateStart;
                trackingData.to_date = query.docQuery.dateEnd;
                /* jshint ignore:end */
            }

            /* jshint ignore:start */
            trackingData.user_id = currentUser.email + ' (' + currentUser._id + ') ' + currentCompany.name;
            /* jshint ignore:end */

            this.AnalyticsService.trackIcmSearchOperation(trackingData);
        }.bind(this));
    };

    /*
        ----------------------------------
        -------- Local Functions ---------
        ----------------------------------
    */
    function getChildBeats(beats) {
        var childBeats = [];

        for (var i = 0; i < beats.length; i++) {
            for (var j = 0; j < beats[i].children.length; j++) {
                // Autocomplete for beats requires parentKey
                var beatToDisplay = JSON.parse(JSON.stringify(beats[i].children[j]));
                beatToDisplay.parentKey = beats[i].key;
                beatToDisplay.parentName = beats[i].name;
                childBeats.push(beatToDisplay);
            }
        }

        return childBeats;
    }

    // Finds the index of a given "value" on a "list" of objects at the specified "field"
    function indexOf(field, value, list) {
        var index = -1;
        for (var i = 0, len = list.length; i < len; i++) {
            if (list[i][field] === value) {
                index = i;
                break;
            }
        }
        return index;
    }

    function collapseAllFilters() {
        var panelObject,
            i,
            panels = angular.element.find('mw-expansion-panel, mw-location-expansion-panel, mw-email-address-expansion-panel, mw-list-status-expansion-panel');

        if (panels.length) {
            for (i = 0; i < panels.length; i++) {
                panelObject = $(panels[i]);
                if (panelObject.hasClass('active')) {
                    panelObject.find('.expand-icon').css('display', 'inline-block');
                    panelObject.find('.collapse-icon').css('display', 'none');
                    panelObject.find('md-card-content').css('display', 'none');
                    panelObject.removeClass('active');
                }
            }
        }
    }

    function getSearchChipValues(searchChips) {
        var searchChipDisplayValues = [];

        if (Array.isArray(searchChips) && searchChips.length) {
            searchChips.forEach(function (searchChip) {
                if (searchChip.type.toLowerCase() === 'standard') {
                    searchChipDisplayValues.push(searchChip.value);
                }
            });
        }

        return searchChipDisplayValues;
    }
}());
